/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.1.2.0 (NJsonSchema v10.0.24.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {default_headers, getAuthToken} from './AuthHeaders';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class ClientBase {
    protected transformOptions(options: any) {

        let token = getAuthToken();

        var old_headers: HttpHeaders = <HttpHeaders>options.headers;
        var new_headers: {[key: string]: string} = {};
        old_headers.keys().forEach(k => {
            new_headers[k] = old_headers.get(k);
        });
        if(token && token != '') {
            new_headers["Authorization"] = "Bearer " + token;
        }

        Object.keys(default_headers).forEach(k => {
            new_headers[k] = default_headers[k];
        });

        options.headers = new HttpHeaders(new_headers);

        //console.log("HTTP call, options: " + JSON.stringify(options));
        return Promise.resolve(options);
    }

    protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
        // TODO: Return own result or throw exception to change default processing behavior, 
        // or call processor function to run the default processing logic

        //console.log("Service call: " + url);
        return processor(response);
    }
}

export interface IAdsClient {
    getAds(): Observable<Ads>;
}

@Injectable({
    providedIn: 'root'
})
export class AdsClient extends ClientBase implements IAdsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAds(): Observable<Ads> {
        let url_ = this.baseUrl + "/api/Ads";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAds(<any>response_);
                } catch (e) {
                    return <Observable<Ads>><any>_observableThrow(e);
                }
            } else
                return <Observable<Ads>><any>_observableThrow(response_);
        }));
    }

    protected processGetAds(response: HttpResponseBase): Observable<Ads> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ads.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Ads>(<any>null);
    }
}

export interface IAdveristmentsClient {
    markAsSeenByDemo(model: AdvertisementMarkAsSeenRequestModel): Observable<AdvertisementMarkAsSeenResponseModel>;
    getCategories(): Observable<DTOAdvertisementCategory[]>;
    getCategoriesJS(): Observable<FileResponse | null>;
    getRegions(): Observable<DTORegion[]>;
    getRegionsOnly(): Observable<DTORegion[]>;
    getChildrenSubRegions(subRegionId: number): Observable<DTOSubRegion[]>;
    repost(model: AdvertistmentRepostModel): Observable<AdvertistmentRepostResponse>;
    create(model: AdveristmentCreateModel): Observable<AdveristmentCreateResponse>;
    update(model: AdveristmentUpdateModel): Observable<AdveristmentUpdateResponse>;
    delete(model: AdveristmentDeleteModel): Observable<AdveristmentDeleteResponse>;
    getAdvertisementData(advId?: number | undefined): Observable<AdveristmentGetResponse>;
    get(model: AdveristmentGetModel): Observable<AdveristmentGetResponse>;
    getAdveristmentGetModel(model: GetAdvertisementsRequest): Observable<AdveristmentGetModel>;
    getSearchParams(request: SearchParamsRequest): Observable<SearchParamsResponse>;
    getGoogleKey(): Observable<string>;
    getBlogUrl(): Observable<string>;
    createAdWriteInformation(data: AdWritterInformationRequest): Observable<AdWritterInformationResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class AdveristmentsClient extends ClientBase implements IAdveristmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    markAsSeenByDemo(model: AdvertisementMarkAsSeenRequestModel): Observable<AdvertisementMarkAsSeenResponseModel> {
        let url_ = this.baseUrl + "/api/Adveristments/markAsSeen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkAsSeenByDemo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsSeenByDemo(<any>response_);
                } catch (e) {
                    return <Observable<AdvertisementMarkAsSeenResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdvertisementMarkAsSeenResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsSeenByDemo(response: HttpResponseBase): Observable<AdvertisementMarkAsSeenResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvertisementMarkAsSeenResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvertisementMarkAsSeenResponseModel>(<any>null);
    }

    getCategories(): Observable<DTOAdvertisementCategory[]> {
        let url_ = this.baseUrl + "/api/Adveristments/GetCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategories(<any>response_);
                } catch (e) {
                    return <Observable<DTOAdvertisementCategory[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DTOAdvertisementCategory[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategories(response: HttpResponseBase): Observable<DTOAdvertisementCategory[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DTOAdvertisementCategory.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DTOAdvertisementCategory[]>(<any>null);
    }

    getCategoriesJS(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Adveristments/getcategories/js";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategoriesJS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoriesJS(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoriesJS(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getRegions(): Observable<DTORegion[]> {
        let url_ = this.baseUrl + "/api/Adveristments/GetRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegions(<any>response_);
                } catch (e) {
                    return <Observable<DTORegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DTORegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegions(response: HttpResponseBase): Observable<DTORegion[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DTORegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DTORegion[]>(<any>null);
    }

    getRegionsOnly(): Observable<DTORegion[]> {
        let url_ = this.baseUrl + "/api/Adveristments/GetRegionsOnly";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRegionsOnly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionsOnly(<any>response_);
                } catch (e) {
                    return <Observable<DTORegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DTORegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegionsOnly(response: HttpResponseBase): Observable<DTORegion[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DTORegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DTORegion[]>(<any>null);
    }

    getChildrenSubRegions(subRegionId: number): Observable<DTOSubRegion[]> {
        let url_ = this.baseUrl + "/api/Adveristments/GetChildrenSubRegions/{subRegionId}";
        if (subRegionId === undefined || subRegionId === null)
            throw new Error("The parameter 'subRegionId' must be defined.");
        url_ = url_.replace("{subRegionId}", encodeURIComponent("" + subRegionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChildrenSubRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChildrenSubRegions(<any>response_);
                } catch (e) {
                    return <Observable<DTOSubRegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DTOSubRegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetChildrenSubRegions(response: HttpResponseBase): Observable<DTOSubRegion[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DTOSubRegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DTOSubRegion[]>(<any>null);
    }

    repost(model: AdvertistmentRepostModel): Observable<AdvertistmentRepostResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/repost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRepost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRepost(<any>response_);
                } catch (e) {
                    return <Observable<AdvertistmentRepostResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdvertistmentRepostResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRepost(response: HttpResponseBase): Observable<AdvertistmentRepostResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvertistmentRepostResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvertistmentRepostResponse>(<any>null);
    }

    create(model: AdveristmentCreateModel): Observable<AdveristmentCreateResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<AdveristmentCreateResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdveristmentCreateResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AdveristmentCreateResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdveristmentCreateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdveristmentCreateResponse>(<any>null);
    }

    update(model: AdveristmentUpdateModel): Observable<AdveristmentUpdateResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<AdveristmentUpdateResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdveristmentUpdateResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AdveristmentUpdateResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdveristmentUpdateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdveristmentUpdateResponse>(<any>null);
    }

    delete(model: AdveristmentDeleteModel): Observable<AdveristmentDeleteResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<AdveristmentDeleteResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdveristmentDeleteResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<AdveristmentDeleteResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdveristmentDeleteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdveristmentDeleteResponse>(<any>null);
    }

    getAdvertisementData(advId?: number | undefined): Observable<AdveristmentGetResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/GetAdvertisementData?";
        if (advId === null)
            throw new Error("The parameter 'advId' cannot be null.");
        else if (advId !== undefined)
            url_ += "advId=" + encodeURIComponent("" + advId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAdvertisementData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertisementData(<any>response_);
                } catch (e) {
                    return <Observable<AdveristmentGetResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdveristmentGetResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdvertisementData(response: HttpResponseBase): Observable<AdveristmentGetResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdveristmentGetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdveristmentGetResponse>(<any>null);
    }

    get(model: AdveristmentGetModel): Observable<AdveristmentGetResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<AdveristmentGetResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdveristmentGetResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AdveristmentGetResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdveristmentGetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdveristmentGetResponse>(<any>null);
    }

    getAdveristmentGetModel(model: GetAdvertisementsRequest): Observable<AdveristmentGetModel> {
        let url_ = this.baseUrl + "/api/Adveristments/GetAdveristmentGetModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAdveristmentGetModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdveristmentGetModel(<any>response_);
                } catch (e) {
                    return <Observable<AdveristmentGetModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdveristmentGetModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdveristmentGetModel(response: HttpResponseBase): Observable<AdveristmentGetModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdveristmentGetModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdveristmentGetModel>(<any>null);
    }

    getSearchParams(request: SearchParamsRequest): Observable<SearchParamsResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/SearchParams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSearchParams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchParams(<any>response_);
                } catch (e) {
                    return <Observable<SearchParamsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchParamsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSearchParams(response: HttpResponseBase): Observable<SearchParamsResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchParamsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchParamsResponse>(<any>null);
    }

    getGoogleKey(): Observable<string> {
        let url_ = this.baseUrl + "/api/Adveristments/GetGoogleKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGoogleKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoogleKey(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetGoogleKey(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    getBlogUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/Adveristments/GetBlogUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBlogUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlogUrl(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetBlogUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    createAdWriteInformation(data: AdWritterInformationRequest): Observable<AdWritterInformationResponse> {
        let url_ = this.baseUrl + "/api/Adveristments/CreateAdWriteInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAdWriteInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAdWriteInformation(<any>response_);
                } catch (e) {
                    return <Observable<AdWritterInformationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdWritterInformationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAdWriteInformation(response: HttpResponseBase): Observable<AdWritterInformationResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdWritterInformationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdWritterInformationResponse>(<any>null);
    }
}

export interface IAuthClient {
    login(user: LoginModel): Observable<LoginResponseModel>;
}

@Injectable({
    providedIn: 'root'
})
export class AuthClient extends ClientBase implements IAuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    login(user: LoginModel): Observable<LoginResponseModel> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<LoginResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoginResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponseModel>(<any>null);
    }
}

export interface IBannersClient {
    getBannersEnabled(): Observable<string>;
    getUseBannerProviders(): Observable<string>;
    getAllUserBaners(isMobile?: number | undefined): Observable<Baners[]>;
}

@Injectable({
    providedIn: 'root'
})
export class BannersClient extends ClientBase implements IBannersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getBannersEnabled(): Observable<string> {
        let url_ = this.baseUrl + "/api/Banners/GetBannersEnabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBannersEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBannersEnabled(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetBannersEnabled(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    getUseBannerProviders(): Observable<string> {
        let url_ = this.baseUrl + "/api/Banners/GetUseBannerProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUseBannerProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUseBannerProviders(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetUseBannerProviders(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    getAllUserBaners(isMobile?: number | undefined): Observable<Baners[]> {
        let url_ = this.baseUrl + "/api/Banners/GetAllUserBaners?";
        if (isMobile === null)
            throw new Error("The parameter 'isMobile' cannot be null.");
        else if (isMobile !== undefined)
            url_ += "isMobile=" + encodeURIComponent("" + isMobile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUserBaners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserBaners(<any>response_);
                } catch (e) {
                    return <Observable<Baners[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Baners[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserBaners(response: HttpResponseBase): Observable<Baners[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Baners.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Baners[]>(<any>null);
    }
}

export interface ICaptchaClient {
    getCaptchaKey(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CaptchaClient extends ClientBase implements ICaptchaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getCaptchaKey(): Observable<string> {
        let url_ = this.baseUrl + "/api/Captcha/GetCaptchaKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCaptchaKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaptchaKey(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetCaptchaKey(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface IConversationClient {
    deleteConversation(deleteRequestModel: ConversationDeleteRequestModel): Observable<ConversationDeleteResponseModel>;
    getConversation(conversationId?: number | undefined): Observable<GetConversationResponseModel>;
    getConversations(requestModel: UserConversationsRequestModel, perPage?: number | undefined, page?: number | undefined): Observable<UserConversationsResponseModel>;
    getConversationsCount(requestModel: UserConversationsRequestModel): Observable<number>;
    sendConversationMessage(requestModel: ConversationMessageSubmitRequestModel): Observable<MessageSubmitResponseModel>;
    sendStartingMessage(requestModel: StartConversationMessageSubmitRequestModel): Observable<MessageSubmitResponseModel>;
    getUnreadedMessages(): Observable<number>;
    setReadedMessages(messagesIds: number[], conversationId?: number | undefined): Observable<boolean>;
    getActiveConversationId(advertisementId?: number | undefined): Observable<number>;
    restoreConvHasMessages(): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class ConversationClient extends ClientBase implements IConversationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    deleteConversation(deleteRequestModel: ConversationDeleteRequestModel): Observable<ConversationDeleteResponseModel> {
        let url_ = this.baseUrl + "/api/Conversation/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteRequestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConversation(<any>response_);
                } catch (e) {
                    return <Observable<ConversationDeleteResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConversationDeleteResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteConversation(response: HttpResponseBase): Observable<ConversationDeleteResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConversationDeleteResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConversationDeleteResponseModel>(<any>null);
    }

    getConversation(conversationId?: number | undefined): Observable<GetConversationResponseModel> {
        let url_ = this.baseUrl + "/api/Conversation/getConversation?";
        if (conversationId === null)
            throw new Error("The parameter 'conversationId' cannot be null.");
        else if (conversationId !== undefined)
            url_ += "conversationId=" + encodeURIComponent("" + conversationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConversation(<any>response_);
                } catch (e) {
                    return <Observable<GetConversationResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConversationResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetConversation(response: HttpResponseBase): Observable<GetConversationResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConversationResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConversationResponseModel>(<any>null);
    }

    getConversations(requestModel: UserConversationsRequestModel, perPage?: number | undefined, page?: number | undefined): Observable<UserConversationsResponseModel> {
        let url_ = this.baseUrl + "/api/Conversation/get?";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&"; 
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConversations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConversations(<any>response_);
                } catch (e) {
                    return <Observable<UserConversationsResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserConversationsResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetConversations(response: HttpResponseBase): Observable<UserConversationsResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserConversationsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserConversationsResponseModel>(<any>null);
    }

    getConversationsCount(requestModel: UserConversationsRequestModel): Observable<number> {
        let url_ = this.baseUrl + "/api/Conversation/getCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConversationsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConversationsCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetConversationsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    sendConversationMessage(requestModel: ConversationMessageSubmitRequestModel): Observable<MessageSubmitResponseModel> {
        let url_ = this.baseUrl + "/api/Conversation/sendConversationMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendConversationMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConversationMessage(<any>response_);
                } catch (e) {
                    return <Observable<MessageSubmitResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageSubmitResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSendConversationMessage(response: HttpResponseBase): Observable<MessageSubmitResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageSubmitResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageSubmitResponseModel>(<any>null);
    }

    sendStartingMessage(requestModel: StartConversationMessageSubmitRequestModel): Observable<MessageSubmitResponseModel> {
        let url_ = this.baseUrl + "/api/Conversation/sendStartingMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendStartingMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendStartingMessage(<any>response_);
                } catch (e) {
                    return <Observable<MessageSubmitResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageSubmitResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSendStartingMessage(response: HttpResponseBase): Observable<MessageSubmitResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageSubmitResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageSubmitResponseModel>(<any>null);
    }

    getUnreadedMessages(): Observable<number> {
        let url_ = this.baseUrl + "/api/Conversation/GetUnreadedMessages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUnreadedMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadedMessages(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnreadedMessages(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    setReadedMessages(messagesIds: number[], conversationId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Conversation/SetReadedMessages?";
        if (conversationId === null)
            throw new Error("The parameter 'conversationId' cannot be null.");
        else if (conversationId !== undefined)
            url_ += "conversationId=" + encodeURIComponent("" + conversationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messagesIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetReadedMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetReadedMessages(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetReadedMessages(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getActiveConversationId(advertisementId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Conversation/GetActiveConversationId?";
        if (advertisementId === null)
            throw new Error("The parameter 'advertisementId' cannot be null.");
        else if (advertisementId !== undefined)
            url_ += "advertisementId=" + encodeURIComponent("" + advertisementId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetActiveConversationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveConversationId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveConversationId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    restoreConvHasMessages(): Observable<number> {
        let url_ = this.baseUrl + "/api/Conversation/restoreConvsHasMessages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRestoreConvHasMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreConvHasMessages(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processRestoreConvHasMessages(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

export interface IEmojiClient {
    getEmojis(): Observable<EmojiResponseModel>;
}

@Injectable({
    providedIn: 'root'
})
export class EmojiClient extends ClientBase implements IEmojiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getEmojis(): Observable<EmojiResponseModel> {
        let url_ = this.baseUrl + "/api/Emoji/GetEmojis";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmojis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmojis(<any>response_);
                } catch (e) {
                    return <Observable<EmojiResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmojiResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmojis(response: HttpResponseBase): Observable<EmojiResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmojiResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmojiResponseModel>(<any>null);
    }
}

export interface IFileClient {
    read(pathInfo: string | null, maxWidth: number, maxheight: number): Observable<FileResponse | null>;
    read2(pathInfo: string | null): Observable<FileResponse | null>;
    temporaryUpload(): Observable<FileResponse | null>;
    temporaryBanerUpload(): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class FileClient extends ClientBase implements IFileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    read(pathInfo: string | null, maxWidth: number, maxheight: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/FileGet/{pathInfo}/{maxWidth}x{maxheight}";
        if (pathInfo === undefined || pathInfo === null)
            throw new Error("The parameter 'pathInfo' must be defined.");
        url_ = url_.replace("{pathInfo}", encodeURIComponent("" + pathInfo)); 
        if (maxWidth === undefined || maxWidth === null)
            throw new Error("The parameter 'maxWidth' must be defined.");
        url_ = url_.replace("{maxWidth}", encodeURIComponent("" + maxWidth)); 
        if (maxheight === undefined || maxheight === null)
            throw new Error("The parameter 'maxheight' must be defined.");
        url_ = url_.replace("{maxheight}", encodeURIComponent("" + maxheight)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRead(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRead(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    read2(pathInfo: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/FileGet/{pathInfo}";
        if (pathInfo === undefined || pathInfo === null)
            throw new Error("The parameter 'pathInfo' must be defined.");
        url_ = url_.replace("{pathInfo}", encodeURIComponent("" + pathInfo)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRead2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRead2(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRead2(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    temporaryUpload(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/File/TemporaryUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTemporaryUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTemporaryUpload(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processTemporaryUpload(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    temporaryBanerUpload(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/File/TemporaryBanerUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTemporaryBanerUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTemporaryBanerUpload(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processTemporaryBanerUpload(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

export interface IGeolocationClient {
    subRegionByLatLng(latitude?: number | undefined, longitude?: number | undefined): Observable<SubRegion>;
    asd(): Observable<SubRegion[]>;
    subregionInformation(id: number): Observable<SubRegion>;
    cityMostPopulation(top?: number | undefined): Observable<SubRegion[]>;
    cityMostPopulationJS(top?: number | undefined): Observable<FileResponse | null>;
    getSubregionByZip(zip?: string | null | undefined): Observable<SubRegion>;
    getSubregionByIP(ip?: string | null | undefined): Observable<SubRegion>;
    ip(): Observable<GetAdvertisementsRequest>;
    getGeolocationSearchModel(ip?: string | null | undefined): Observable<AdveristmentGetModel>;
    clientIp(): Observable<string[]>;
    getNearestCity(ip?: string | null | undefined): Observable<string>;
    allSubregions(): Observable<SubRegion[]>;
    allRegions(): Observable<Region[]>;
    getSubregion(subregionId?: number | undefined): Observable<SubRegion>;
    getRegion(regionId?: number | undefined): Observable<Region>;
}

@Injectable({
    providedIn: 'root'
})
export class GeolocationClient extends ClientBase implements IGeolocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    subRegionByLatLng(latitude?: number | undefined, longitude?: number | undefined): Observable<SubRegion> {
        let url_ = this.baseUrl + "/api/Geolocation/ClosestSubRegionByLatLng?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&"; 
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSubRegionByLatLng(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubRegionByLatLng(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion>><any>_observableThrow(response_);
        }));
    }

    protected processSubRegionByLatLng(response: HttpResponseBase): Observable<SubRegion> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubRegion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion>(<any>null);
    }

    asd(): Observable<SubRegion[]> {
        let url_ = this.baseUrl + "/api/Geolocation/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAsd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAsd(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processAsd(response: HttpResponseBase): Observable<SubRegion[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubRegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion[]>(<any>null);
    }

    subregionInformation(id: number): Observable<SubRegion> {
        let url_ = this.baseUrl + "/api/Geolocation/SubregionInformation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSubregionInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubregionInformation(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion>><any>_observableThrow(response_);
        }));
    }

    protected processSubregionInformation(response: HttpResponseBase): Observable<SubRegion> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubRegion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion>(<any>null);
    }

    cityMostPopulation(top?: number | undefined): Observable<SubRegion[]> {
        let url_ = this.baseUrl + "/citybypopulation?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCityMostPopulation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCityMostPopulation(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processCityMostPopulation(response: HttpResponseBase): Observable<SubRegion[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubRegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion[]>(<any>null);
    }

    cityMostPopulationJS(top?: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/citybypopulation/js?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCityMostPopulationJS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCityMostPopulationJS(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processCityMostPopulationJS(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getSubregionByZip(zip?: string | null | undefined): Observable<SubRegion> {
        let url_ = this.baseUrl + "/SubregionByZip?";
        if (zip !== undefined)
            url_ += "zip=" + encodeURIComponent("" + zip) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubregionByZip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubregionByZip(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubregionByZip(response: HttpResponseBase): Observable<SubRegion> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubRegion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion>(<any>null);
    }

    getSubregionByIP(ip?: string | null | undefined): Observable<SubRegion> {
        let url_ = this.baseUrl + "/GetSubregionByIP?";
        if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubregionByIP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubregionByIP(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubregionByIP(response: HttpResponseBase): Observable<SubRegion> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubRegion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion>(<any>null);
    }

    ip(): Observable<GetAdvertisementsRequest> {
        let url_ = this.baseUrl + "/api/Geolocation/ipstack";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processIp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIp(<any>response_);
                } catch (e) {
                    return <Observable<GetAdvertisementsRequest>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAdvertisementsRequest>><any>_observableThrow(response_);
        }));
    }

    protected processIp(response: HttpResponseBase): Observable<GetAdvertisementsRequest> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdvertisementsRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdvertisementsRequest>(<any>null);
    }

    getGeolocationSearchModel(ip?: string | null | undefined): Observable<AdveristmentGetModel> {
        let url_ = this.baseUrl + "/api/Geolocation/ipdata?";
        if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeolocationSearchModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeolocationSearchModel(<any>response_);
                } catch (e) {
                    return <Observable<AdveristmentGetModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdveristmentGetModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeolocationSearchModel(response: HttpResponseBase): Observable<AdveristmentGetModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdveristmentGetModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdveristmentGetModel>(<any>null);
    }

    clientIp(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Geolocation/clientIP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processClientIp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientIp(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processClientIp(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    getNearestCity(ip?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/GetNearestCity?";
        if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNearestCity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNearestCity(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetNearestCity(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    allSubregions(): Observable<SubRegion[]> {
        let url_ = this.baseUrl + "/api/Geolocation/AllSubregions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAllSubregions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllSubregions(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processAllSubregions(response: HttpResponseBase): Observable<SubRegion[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubRegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion[]>(<any>null);
    }

    allRegions(): Observable<Region[]> {
        let url_ = this.baseUrl + "/api/Geolocation/AllRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAllRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllRegions(<any>response_);
                } catch (e) {
                    return <Observable<Region[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Region[]>><any>_observableThrow(response_);
        }));
    }

    protected processAllRegions(response: HttpResponseBase): Observable<Region[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Region.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Region[]>(<any>null);
    }

    getSubregion(subregionId?: number | undefined): Observable<SubRegion> {
        let url_ = this.baseUrl + "/api/Geolocation/GetSubregion?";
        if (subregionId === null)
            throw new Error("The parameter 'subregionId' cannot be null.");
        else if (subregionId !== undefined)
            url_ += "subregionId=" + encodeURIComponent("" + subregionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubregion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubregion(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubregion(response: HttpResponseBase): Observable<SubRegion> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubRegion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion>(<any>null);
    }

    getRegion(regionId?: number | undefined): Observable<Region> {
        let url_ = this.baseUrl + "/api/Geolocation/GetRegion?";
        if (regionId === null)
            throw new Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegion(<any>response_);
                } catch (e) {
                    return <Observable<Region>><any>_observableThrow(e);
                }
            } else
                return <Observable<Region>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegion(response: HttpResponseBase): Observable<Region> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Region.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Region>(<any>null);
    }
}

export interface IImportDataClient {
    usStates(): Observable<boolean>;
    test(): Observable<SubRegion[]>;
    importPopularity(): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class ImportDataClient extends ClientBase implements IImportDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    usStates(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ImportData/usstates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUsStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsStates(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUsStates(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    test(): Observable<SubRegion[]> {
        let url_ = this.baseUrl + "/api/ImportData/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(<any>response_);
                } catch (e) {
                    return <Observable<SubRegion[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubRegion[]>><any>_observableThrow(response_);
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<SubRegion[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubRegion.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubRegion[]>(<any>null);
    }

    importPopularity(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ImportData/popularity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processImportPopularity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPopularity(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processImportPopularity(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export interface IPhoneValidationClient {
    sendPhoneValidationSms(model: VerifyPhoneModel): Observable<VerifyPhoneResponseModel>;
}

@Injectable({
    providedIn: 'root'
})
export class PhoneValidationClient extends ClientBase implements IPhoneValidationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sendPhoneValidationSms(model: VerifyPhoneModel): Observable<VerifyPhoneResponseModel> {
        let url_ = this.baseUrl + "/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendPhoneValidationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPhoneValidationSms(<any>response_);
                } catch (e) {
                    return <Observable<VerifyPhoneResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<VerifyPhoneResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processSendPhoneValidationSms(response: HttpResponseBase): Observable<VerifyPhoneResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyPhoneResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VerifyPhoneResponseModel>(<any>null);
    }
}

export interface ISampleDataClient {
    zipTest(zip: ZipRequest): Observable<string>;
    weatherForecasts(): Observable<WeatherForecast[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SampleDataClient extends ClientBase implements ISampleDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    zipTest(zip: ZipRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/SampleData/ZipTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zip);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processZipTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZipTest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processZipTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    weatherForecasts(): Observable<WeatherForecast[]> {
        let url_ = this.baseUrl + "/api/SampleData/WeatherForecasts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processWeatherForecasts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWeatherForecasts(<any>response_);
                } catch (e) {
                    return <Observable<WeatherForecast[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WeatherForecast[]>><any>_observableThrow(response_);
        }));
    }

    protected processWeatherForecasts(response: HttpResponseBase): Observable<WeatherForecast[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeatherForecast.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WeatherForecast[]>(<any>null);
    }
}

export interface ISeoClient {
    seoTextJs(): Observable<FileResponse | null>;
    seoPage(slug?: string | null | undefined): Observable<FileResponse | null>;
    getMetaSeo(slug?: string | null | undefined): Observable<GetSeoMetaTextsResponseModel>;
}

@Injectable({
    providedIn: 'root'
})
export class SeoClient extends ClientBase implements ISeoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    seoTextJs(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Seo/texts/js";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSeoTextJs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSeoTextJs(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processSeoTextJs(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    seoPage(slug?: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Seo?";
        if (slug !== undefined)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSeoPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSeoPage(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processSeoPage(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getMetaSeo(slug?: string | null | undefined): Observable<GetSeoMetaTextsResponseModel> {
        let url_ = this.baseUrl + "/api/Seo/getMetaSeo?";
        if (slug !== undefined)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMetaSeo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetaSeo(<any>response_);
                } catch (e) {
                    return <Observable<GetSeoMetaTextsResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSeoMetaTextsResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetMetaSeo(response: HttpResponseBase): Observable<GetSeoMetaTextsResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeoMetaTextsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSeoMetaTextsResponseModel>(<any>null);
    }
}

export interface ISitemapClient {
    getSitemap(): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class SitemapClient extends ClientBase implements ISitemapClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getSitemap(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/sitemap.xml";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSitemap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSitemap(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetSitemap(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

export interface ISubscribtionClient {
    create(data: Subscribe): Observable<CreateServiceResponse>;
    subscribtionData(): Observable<SubscribtionData[]>;
    cancelSubscribtion(subscribtionId?: string | null | undefined): Observable<boolean>;
    hasUserSubscribtion(): Observable<boolean>;
    createPremiumAdToken(data: AddPremiumAdToken): Observable<AddPremiumAdTokenResponse>;
    getUserPremiumAdTokens(): Observable<number>;
    createWriteAdToken(data: AddWriteAdToken): Observable<AddWriteAdTokenResponse>;
    getWriteAdToken(): Observable<number>;
    createThirdPartyAdToken(data: AddThirdPartyAdToken): Observable<AddThirdPartyAdTokenResponse>;
    getUserThirdPartyAdTokens(): Observable<number>;
    createBanerAdvertising(data: AddBaner): Observable<AddBanerResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SubscribtionClient extends ClientBase implements ISubscribtionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    create(data: Subscribe): Observable<CreateServiceResponse> {
        let url_ = this.baseUrl + "/api/Subscribtion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CreateServiceResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateServiceResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateServiceResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateServiceResponse>(<any>null);
    }

    subscribtionData(): Observable<SubscribtionData[]> {
        let url_ = this.baseUrl + "/api/Subscribtion/GetSubscribtionData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSubscribtionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribtionData(<any>response_);
                } catch (e) {
                    return <Observable<SubscribtionData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscribtionData[]>><any>_observableThrow(response_);
        }));
    }

    protected processSubscribtionData(response: HttpResponseBase): Observable<SubscribtionData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribtionData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscribtionData[]>(<any>null);
    }

    cancelSubscribtion(subscribtionId?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Subscribtion/CancelSubscribtion?";
        if (subscribtionId !== undefined)
            url_ += "subscribtionId=" + encodeURIComponent("" + subscribtionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelSubscribtion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSubscribtion(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCancelSubscribtion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    hasUserSubscribtion(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Subscribtion/HasUserSubscribtion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processHasUserSubscribtion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasUserSubscribtion(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processHasUserSubscribtion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    createPremiumAdToken(data: AddPremiumAdToken): Observable<AddPremiumAdTokenResponse> {
        let url_ = this.baseUrl + "/api/Subscribtion/CreatePremiumAdToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePremiumAdToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePremiumAdToken(<any>response_);
                } catch (e) {
                    return <Observable<AddPremiumAdTokenResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddPremiumAdTokenResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePremiumAdToken(response: HttpResponseBase): Observable<AddPremiumAdTokenResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPremiumAdTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPremiumAdTokenResponse>(<any>null);
    }

    getUserPremiumAdTokens(): Observable<number> {
        let url_ = this.baseUrl + "/api/Subscribtion/GetUserPremiumAdTokens";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserPremiumAdTokens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPremiumAdTokens(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPremiumAdTokens(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    createWriteAdToken(data: AddWriteAdToken): Observable<AddWriteAdTokenResponse> {
        let url_ = this.baseUrl + "/api/Subscribtion/CreateWriteAdToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateWriteAdToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWriteAdToken(<any>response_);
                } catch (e) {
                    return <Observable<AddWriteAdTokenResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddWriteAdTokenResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreateWriteAdToken(response: HttpResponseBase): Observable<AddWriteAdTokenResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddWriteAdTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddWriteAdTokenResponse>(<any>null);
    }

    getWriteAdToken(): Observable<number> {
        let url_ = this.baseUrl + "/api/Subscribtion/GetWriteAdToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWriteAdToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWriteAdToken(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetWriteAdToken(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    createThirdPartyAdToken(data: AddThirdPartyAdToken): Observable<AddThirdPartyAdTokenResponse> {
        let url_ = this.baseUrl + "/api/Subscribtion/CreateThirdPartyAdToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateThirdPartyAdToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateThirdPartyAdToken(<any>response_);
                } catch (e) {
                    return <Observable<AddThirdPartyAdTokenResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddThirdPartyAdTokenResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreateThirdPartyAdToken(response: HttpResponseBase): Observable<AddThirdPartyAdTokenResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddThirdPartyAdTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddThirdPartyAdTokenResponse>(<any>null);
    }

    getUserThirdPartyAdTokens(): Observable<number> {
        let url_ = this.baseUrl + "/api/Subscribtion/GetUserThirdPartyAdTokens";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserThirdPartyAdTokens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserThirdPartyAdTokens(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserThirdPartyAdTokens(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    createBanerAdvertising(data: AddBaner): Observable<AddBanerResponse> {
        let url_ = this.baseUrl + "/api/Subscribtion/CreateBanerAdvertising";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateBanerAdvertising(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBanerAdvertising(<any>response_);
                } catch (e) {
                    return <Observable<AddBanerResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddBanerResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreateBanerAdvertising(response: HttpResponseBase): Observable<AddBanerResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddBanerResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddBanerResponse>(<any>null);
    }
}

export interface IUserClient {
    register(model: RegistrationModel): Observable<RegistrationResponseModel>;
    resetPassword(model: ResetPasswordModel): Observable<ResetPasswordResponseModel>;
    getEmailFromCode(model: string): Observable<GetEmailFromCodeResponseModel>;
    newPassword(model: NewPasswordModel): Observable<ResetPasswordResponseModel>;
    validatePhone(model: ValidatePhoneModel): Observable<ValidateResponseModel>;
    validateEmail(model: ValidateModel): Observable<ValidateResponseModel>;
    deleteAccount(): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class UserClient extends ClientBase implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    register(model: RegistrationModel): Observable<RegistrationResponseModel> {
        let url_ = this.baseUrl + "/api/User/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegistrationResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegistrationResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegistrationResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegistrationResponseModel>(<any>null);
    }

    resetPassword(model: ResetPasswordModel): Observable<ResetPasswordResponseModel> {
        let url_ = this.baseUrl + "/api/User/passwordreset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<ResetPasswordResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResetPasswordResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordResponseModel>(<any>null);
    }

    getEmailFromCode(model: string): Observable<GetEmailFromCodeResponseModel> {
        let url_ = this.baseUrl + "/api/User/getemailfromcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmailFromCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailFromCode(<any>response_);
                } catch (e) {
                    return <Observable<GetEmailFromCodeResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEmailFromCodeResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmailFromCode(response: HttpResponseBase): Observable<GetEmailFromCodeResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmailFromCodeResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmailFromCodeResponseModel>(<any>null);
    }

    newPassword(model: NewPasswordModel): Observable<ResetPasswordResponseModel> {
        let url_ = this.baseUrl + "/api/User/newpassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNewPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewPassword(<any>response_);
                } catch (e) {
                    return <Observable<ResetPasswordResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResetPasswordResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processNewPassword(response: HttpResponseBase): Observable<ResetPasswordResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordResponseModel>(<any>null);
    }

    validatePhone(model: ValidatePhoneModel): Observable<ValidateResponseModel> {
        let url_ = this.baseUrl + "/api/User/phoneValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processValidatePhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePhone(<any>response_);
                } catch (e) {
                    return <Observable<ValidateResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidateResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processValidatePhone(response: HttpResponseBase): Observable<ValidateResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidateResponseModel>(<any>null);
    }

    validateEmail(model: ValidateModel): Observable<ValidateResponseModel> {
        let url_ = this.baseUrl + "/api/User/emailValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processValidateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateEmail(<any>response_);
                } catch (e) {
                    return <Observable<ValidateResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidateResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processValidateEmail(response: HttpResponseBase): Observable<ValidateResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidateResponseModel>(<any>null);
    }

    deleteAccount(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/DeleteAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccount(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export interface IVersionClient {
    versionHash(t?: string | null | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class VersionClient extends ClientBase implements IVersionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    versionHash(t?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Version?";
        if (t !== undefined)
            url_ += "t=" + encodeURIComponent("" + t) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processVersionHash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVersionHash(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processVersionHash(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export class Ads implements IAds {
    leftAdId?: string | null;
    rightAdId?: string | null;
    mobileAdId?: string | null;

    constructor(data?: IAds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.leftAdId = data["leftAdId"] !== undefined ? data["leftAdId"] : <any>null;
            this.rightAdId = data["rightAdId"] !== undefined ? data["rightAdId"] : <any>null;
            this.mobileAdId = data["mobileAdId"] !== undefined ? data["mobileAdId"] : <any>null;
        }
    }

    static fromJS(data: any): Ads {
        data = typeof data === 'object' ? data : {};
        let result = new Ads();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leftAdId"] = this.leftAdId !== undefined ? this.leftAdId : <any>null;
        data["rightAdId"] = this.rightAdId !== undefined ? this.rightAdId : <any>null;
        data["mobileAdId"] = this.mobileAdId !== undefined ? this.mobileAdId : <any>null;
        return data; 
    }

    clone(): Ads {
        const json = this.toJSON();
        let result = new Ads();
        result.init(json);
        return result;
    }
}

export interface IAds {
    leftAdId?: string | null;
    rightAdId?: string | null;
    mobileAdId?: string | null;
}

export class ResponseBaseModel implements IResponseBaseModel {
    error?: string | null;
    redirectUrl?: string | null;

    constructor(data?: IResponseBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.error = data["error"] !== undefined ? data["error"] : <any>null;
            this.redirectUrl = data["redirectUrl"] !== undefined ? data["redirectUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ResponseBaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseBaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error !== undefined ? this.error : <any>null;
        data["redirectUrl"] = this.redirectUrl !== undefined ? this.redirectUrl : <any>null;
        return data; 
    }

    clone(): ResponseBaseModel {
        const json = this.toJSON();
        let result = new ResponseBaseModel();
        result.init(json);
        return result;
    }
}

export interface IResponseBaseModel {
    error?: string | null;
    redirectUrl?: string | null;
}

export class AdvertisementMarkAsSeenResponseModel extends ResponseBaseModel implements IAdvertisementMarkAsSeenResponseModel {

    constructor(data?: IAdvertisementMarkAsSeenResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): AdvertisementMarkAsSeenResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementMarkAsSeenResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): AdvertisementMarkAsSeenResponseModel {
        const json = this.toJSON();
        let result = new AdvertisementMarkAsSeenResponseModel();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementMarkAsSeenResponseModel extends IResponseBaseModel {
}

export class AdvertisementMarkAsSeenRequestModel implements IAdvertisementMarkAsSeenRequestModel {
    advertisementId!: number;
    isAdmin!: boolean;

    constructor(data?: IAdvertisementMarkAsSeenRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : <any>null;
            this.isAdmin = data["isAdmin"] !== undefined ? data["isAdmin"] : <any>null;
        }
    }

    static fromJS(data: any): AdvertisementMarkAsSeenRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementMarkAsSeenRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : <any>null;
        return data; 
    }

    clone(): AdvertisementMarkAsSeenRequestModel {
        const json = this.toJSON();
        let result = new AdvertisementMarkAsSeenRequestModel();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementMarkAsSeenRequestModel {
    advertisementId: number;
    isAdmin: boolean;
}

export class DTOBaseModel implements IDTOBaseModel {

    constructor(data?: IDTOBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): DTOBaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DTOBaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): DTOBaseModel {
        const json = this.toJSON();
        let result = new DTOBaseModel();
        result.init(json);
        return result;
    }
}

export interface IDTOBaseModel {
}

export class DTOAdvertisementCategory extends DTOBaseModel implements IDTOAdvertisementCategory {
    advertisementCategoryId!: number;
    name?: string | null;
    code?: string | null;
    orderIndex!: number;
    casualDating!: boolean;

    constructor(data?: IDTOAdvertisementCategory) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.advertisementCategoryId = data["advertisementCategoryId"] !== undefined ? data["advertisementCategoryId"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.code = data["code"] !== undefined ? data["code"] : <any>null;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : <any>null;
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : <any>null;
        }
    }

    static fromJS(data: any): DTOAdvertisementCategory {
        data = typeof data === 'object' ? data : {};
        let result = new DTOAdvertisementCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): DTOAdvertisementCategory {
        const json = this.toJSON();
        let result = new DTOAdvertisementCategory();
        result.init(json);
        return result;
    }
}

export interface IDTOAdvertisementCategory extends IDTOBaseModel {
    advertisementCategoryId: number;
    name?: string | null;
    code?: string | null;
    orderIndex: number;
    casualDating: boolean;
}

export class DTORegion extends DTOBaseModel implements IDTORegion {
    regionId!: number;
    shortName?: string | null;
    name?: string | null;
    isActive!: boolean;
    subRegions?: DTOSubRegion[] | null;

    constructor(data?: IDTORegion) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : <any>null;
            this.shortName = data["shortName"] !== undefined ? data["shortName"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : <any>null;
            if (Array.isArray(data["subRegions"])) {
                this.subRegions = [] as any;
                for (let item of data["subRegions"])
                    this.subRegions!.push(DTOSubRegion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DTORegion {
        data = typeof data === 'object' ? data : {};
        let result = new DTORegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.subRegions)) {
            data["subRegions"] = [];
            for (let item of this.subRegions)
                data["subRegions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): DTORegion {
        const json = this.toJSON();
        let result = new DTORegion();
        result.init(json);
        return result;
    }
}

export interface IDTORegion extends IDTOBaseModel {
    regionId: number;
    shortName?: string | null;
    name?: string | null;
    isActive: boolean;
    subRegions?: DTOSubRegion[] | null;
}

export class DTOSubRegion extends DTOBaseModel implements IDTOSubRegion {
    subRegionId!: number;
    shortName?: string | null;
    shortRegionSubregion?: string | null;
    name?: string | null;
    isActive!: boolean;
    regionId!: number;
    zip?: string | null;

    constructor(data?: IDTOSubRegion) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.subRegionId = data["subRegionId"] !== undefined ? data["subRegionId"] : <any>null;
            this.shortName = data["shortName"] !== undefined ? data["shortName"] : <any>null;
            this.shortRegionSubregion = data["shortRegionSubregion"] !== undefined ? data["shortRegionSubregion"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : <any>null;
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : <any>null;
            this.zip = data["zip"] !== undefined ? data["zip"] : <any>null;
        }
    }

    static fromJS(data: any): DTOSubRegion {
        data = typeof data === 'object' ? data : {};
        let result = new DTOSubRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["shortRegionSubregion"] = this.shortRegionSubregion !== undefined ? this.shortRegionSubregion : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): DTOSubRegion {
        const json = this.toJSON();
        let result = new DTOSubRegion();
        result.init(json);
        return result;
    }
}

export interface IDTOSubRegion extends IDTOBaseModel {
    subRegionId: number;
    shortName?: string | null;
    shortRegionSubregion?: string | null;
    name?: string | null;
    isActive: boolean;
    regionId: number;
    zip?: string | null;
}

export class AdvertistmentRepostResponse extends ResponseBaseModel implements IAdvertistmentRepostResponse {
    isReposted!: boolean;

    constructor(data?: IAdvertistmentRepostResponse) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.isReposted = data["isReposted"] !== undefined ? data["isReposted"] : <any>null;
        }
    }

    static fromJS(data: any): AdvertistmentRepostResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertistmentRepostResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isReposted"] = this.isReposted !== undefined ? this.isReposted : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdvertistmentRepostResponse {
        const json = this.toJSON();
        let result = new AdvertistmentRepostResponse();
        result.init(json);
        return result;
    }
}

export interface IAdvertistmentRepostResponse extends IResponseBaseModel {
    isReposted: boolean;
}

export class DTOAdvertisement extends DTOBaseModel implements IDTOAdvertisement {
    advertisementId?: number | null;
    regionId?: number | null;
    seen!: boolean;
    seenAdmin!: boolean;
    subRegionId?: number | null;
    zipCode?: string | null;
    location?: string | null;
    dateStart?: moment.Moment | null;
    dateEnd?: moment.Moment | null;
    title?: string | null;
    content?: string | null;
    published?: boolean | null;
    casualDating?: boolean | null;
    advertisementCategoryId?: number | null;
    isPremium!: boolean;
    isPremiumUser?: boolean | null;
    isThirdParty!: boolean;
    regionName?: string | null;
    regionShortName?: string | null;
    subRegionName?: string | null;
    categoryCode?: string | null;
    images?: DTOAdvertisementImage[] | null;
    userId?: number | null;
    userNick?: string | null;
    moderated?: boolean | null;
    moderatedAt?: moment.Moment | null;
    moderatedBy?: number | null;
    moderateText?: string | null;
    age?: string | null;
    locationDescription?: string | null;
    isDemo!: boolean;
    showAs?: ShowAdType | null;

    constructor(data?: IDTOAdvertisement) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : <any>null;
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : <any>null;
            this.seen = data["seen"] !== undefined ? data["seen"] : <any>null;
            this.seenAdmin = data["seenAdmin"] !== undefined ? data["seenAdmin"] : <any>null;
            this.subRegionId = data["subRegionId"] !== undefined ? data["subRegionId"] : <any>null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : <any>null;
            this.location = data["location"] !== undefined ? data["location"] : <any>null;
            this.dateStart = data["dateStart"] ? moment(data["dateStart"].toString()) : <any>null;
            this.dateEnd = data["dateEnd"] ? moment(data["dateEnd"].toString()) : <any>null;
            this.title = data["title"] !== undefined ? data["title"] : <any>null;
            this.content = data["content"] !== undefined ? data["content"] : <any>null;
            this.published = data["published"] !== undefined ? data["published"] : <any>null;
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : <any>null;
            this.advertisementCategoryId = data["advertisementCategoryId"] !== undefined ? data["advertisementCategoryId"] : <any>null;
            this.isPremium = data["isPremium"] !== undefined ? data["isPremium"] : <any>null;
            this.isPremiumUser = data["isPremiumUser"] !== undefined ? data["isPremiumUser"] : <any>null;
            this.isThirdParty = data["isThirdParty"] !== undefined ? data["isThirdParty"] : <any>null;
            this.regionName = data["regionName"] !== undefined ? data["regionName"] : <any>null;
            this.regionShortName = data["regionShortName"] !== undefined ? data["regionShortName"] : <any>null;
            this.subRegionName = data["subRegionName"] !== undefined ? data["subRegionName"] : <any>null;
            this.categoryCode = data["categoryCode"] !== undefined ? data["categoryCode"] : <any>null;
            if (Array.isArray(data["images"])) {
                this.images = [] as any;
                for (let item of data["images"])
                    this.images!.push(DTOAdvertisementImage.fromJS(item));
            }
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.userNick = data["userNick"] !== undefined ? data["userNick"] : <any>null;
            this.moderated = data["moderated"] !== undefined ? data["moderated"] : <any>null;
            this.moderatedAt = data["moderatedAt"] ? moment(data["moderatedAt"].toString()) : <any>null;
            this.moderatedBy = data["moderatedBy"] !== undefined ? data["moderatedBy"] : <any>null;
            this.moderateText = data["moderateText"] !== undefined ? data["moderateText"] : <any>null;
            this.age = data["age"] !== undefined ? data["age"] : <any>null;
            this.locationDescription = data["locationDescription"] !== undefined ? data["locationDescription"] : <any>null;
            this.isDemo = data["isDemo"] !== undefined ? data["isDemo"] : <any>null;
            this.showAs = data["showAs"] !== undefined ? data["showAs"] : <any>null;
        }
    }

    static fromJS(data: any): DTOAdvertisement {
        data = typeof data === 'object' ? data : {};
        let result = new DTOAdvertisement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["seen"] = this.seen !== undefined ? this.seen : <any>null;
        data["seenAdmin"] = this.seenAdmin !== undefined ? this.seenAdmin : <any>null;
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>null;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["published"] = this.published !== undefined ? this.published : <any>null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : <any>null;
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : <any>null;
        data["isPremium"] = this.isPremium !== undefined ? this.isPremium : <any>null;
        data["isPremiumUser"] = this.isPremiumUser !== undefined ? this.isPremiumUser : <any>null;
        data["isThirdParty"] = this.isThirdParty !== undefined ? this.isThirdParty : <any>null;
        data["regionName"] = this.regionName !== undefined ? this.regionName : <any>null;
        data["regionShortName"] = this.regionShortName !== undefined ? this.regionShortName : <any>null;
        data["subRegionName"] = this.subRegionName !== undefined ? this.subRegionName : <any>null;
        data["categoryCode"] = this.categoryCode !== undefined ? this.categoryCode : <any>null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["userNick"] = this.userNick !== undefined ? this.userNick : <any>null;
        data["moderated"] = this.moderated !== undefined ? this.moderated : <any>null;
        data["moderatedAt"] = this.moderatedAt ? this.moderatedAt.toISOString() : <any>null;
        data["moderatedBy"] = this.moderatedBy !== undefined ? this.moderatedBy : <any>null;
        data["moderateText"] = this.moderateText !== undefined ? this.moderateText : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["locationDescription"] = this.locationDescription !== undefined ? this.locationDescription : <any>null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : <any>null;
        data["showAs"] = this.showAs !== undefined ? this.showAs : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): DTOAdvertisement {
        const json = this.toJSON();
        let result = new DTOAdvertisement();
        result.init(json);
        return result;
    }
}

export interface IDTOAdvertisement extends IDTOBaseModel {
    advertisementId?: number | null;
    regionId?: number | null;
    seen: boolean;
    seenAdmin: boolean;
    subRegionId?: number | null;
    zipCode?: string | null;
    location?: string | null;
    dateStart?: moment.Moment | null;
    dateEnd?: moment.Moment | null;
    title?: string | null;
    content?: string | null;
    published?: boolean | null;
    casualDating?: boolean | null;
    advertisementCategoryId?: number | null;
    isPremium: boolean;
    isPremiumUser?: boolean | null;
    isThirdParty: boolean;
    regionName?: string | null;
    regionShortName?: string | null;
    subRegionName?: string | null;
    categoryCode?: string | null;
    images?: DTOAdvertisementImage[] | null;
    userId?: number | null;
    userNick?: string | null;
    moderated?: boolean | null;
    moderatedAt?: moment.Moment | null;
    moderatedBy?: number | null;
    moderateText?: string | null;
    age?: string | null;
    locationDescription?: string | null;
    isDemo: boolean;
    showAs?: ShowAdType | null;
}

export class AdveristmentCreateModel extends DTOAdvertisement implements IAdveristmentCreateModel {

    constructor(data?: IAdveristmentCreateModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): AdveristmentCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): AdveristmentCreateModel {
        const json = this.toJSON();
        let result = new AdveristmentCreateModel();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentCreateModel extends IDTOAdvertisement {
}

export class AdveristmentUpdateModel extends AdveristmentCreateModel implements IAdveristmentUpdateModel {
    manageId?: string | null;

    constructor(data?: IAdveristmentUpdateModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.manageId = data["manageId"] !== undefined ? data["manageId"] : <any>null;
        }
    }

    static fromJS(data: any): AdveristmentUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manageId"] = this.manageId !== undefined ? this.manageId : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdveristmentUpdateModel {
        const json = this.toJSON();
        let result = new AdveristmentUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentUpdateModel extends IAdveristmentCreateModel {
    manageId?: string | null;
}

export class AdvertistmentRepostModel extends AdveristmentUpdateModel implements IAdvertistmentRepostModel {

    constructor(data?: IAdvertistmentRepostModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): AdvertistmentRepostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertistmentRepostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): AdvertistmentRepostModel {
        const json = this.toJSON();
        let result = new AdvertistmentRepostModel();
        result.init(json);
        return result;
    }
}

export interface IAdvertistmentRepostModel extends IAdveristmentUpdateModel {
}

export class DTOAdvertisementImage extends DTOBaseModel implements IDTOAdvertisementImage {
    advertisementImageId?: number | null;
    advertisementId?: number | null;
    name?: string | null;
    fileName?: string | null;
    orgFileName?: string | null;
    tempFileName?: string | null;
    orderIndex?: number | null;
    isMain?: boolean | null;

    constructor(data?: IDTOAdvertisementImage) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.advertisementImageId = data["advertisementImageId"] !== undefined ? data["advertisementImageId"] : <any>null;
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : <any>null;
            this.orgFileName = data["orgFileName"] !== undefined ? data["orgFileName"] : <any>null;
            this.tempFileName = data["tempFileName"] !== undefined ? data["tempFileName"] : <any>null;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : <any>null;
            this.isMain = data["isMain"] !== undefined ? data["isMain"] : <any>null;
        }
    }

    static fromJS(data: any): DTOAdvertisementImage {
        data = typeof data === 'object' ? data : {};
        let result = new DTOAdvertisementImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementImageId"] = this.advertisementImageId !== undefined ? this.advertisementImageId : <any>null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["orgFileName"] = this.orgFileName !== undefined ? this.orgFileName : <any>null;
        data["tempFileName"] = this.tempFileName !== undefined ? this.tempFileName : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["isMain"] = this.isMain !== undefined ? this.isMain : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): DTOAdvertisementImage {
        const json = this.toJSON();
        let result = new DTOAdvertisementImage();
        result.init(json);
        return result;
    }
}

export interface IDTOAdvertisementImage extends IDTOBaseModel {
    advertisementImageId?: number | null;
    advertisementId?: number | null;
    name?: string | null;
    fileName?: string | null;
    orgFileName?: string | null;
    tempFileName?: string | null;
    orderIndex?: number | null;
    isMain?: boolean | null;
}

export enum ShowAdType {
    NotSet = 0,
    PremiumAd = 1,
    PremiumUser = 2,
    StandardAd = 3,
    ThirdParty = 4,
}

export class AdveristmentCreateResponse extends ResponseBaseModel implements IAdveristmentCreateResponse {
    advertisementId!: number;

    constructor(data?: IAdveristmentCreateResponse) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : <any>null;
        }
    }

    static fromJS(data: any): AdveristmentCreateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentCreateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdveristmentCreateResponse {
        const json = this.toJSON();
        let result = new AdveristmentCreateResponse();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentCreateResponse extends IResponseBaseModel {
    advertisementId: number;
}

export class AdveristmentUpdateResponse extends AdveristmentCreateResponse implements IAdveristmentUpdateResponse {

    constructor(data?: IAdveristmentUpdateResponse) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): AdveristmentUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): AdveristmentUpdateResponse {
        const json = this.toJSON();
        let result = new AdveristmentUpdateResponse();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentUpdateResponse extends IAdveristmentCreateResponse {
}

export class AdveristmentDeleteResponse extends AdveristmentCreateResponse implements IAdveristmentDeleteResponse {

    constructor(data?: IAdveristmentDeleteResponse) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): AdveristmentDeleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentDeleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): AdveristmentDeleteResponse {
        const json = this.toJSON();
        let result = new AdveristmentDeleteResponse();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentDeleteResponse extends IAdveristmentCreateResponse {
}

export class AdveristmentDeleteModel implements IAdveristmentDeleteModel {
    advertisementId!: number;

    constructor(data?: IAdveristmentDeleteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : <any>null;
        }
    }

    static fromJS(data: any): AdveristmentDeleteModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentDeleteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        return data; 
    }

    clone(): AdveristmentDeleteModel {
        const json = this.toJSON();
        let result = new AdveristmentDeleteModel();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentDeleteModel {
    advertisementId: number;
}

export class AdveristmentGetResponse extends ResponseBaseModel implements IAdveristmentGetResponse {
    adveristments?: DTOAdvertisement[] | null;
    totalResultsCount!: number;
    regionShortName?: string | null;
    subRegionName?: string | null;
    closestSubregionNameIfNoResult?: string | null;

    constructor(data?: IAdveristmentGetResponse) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["adveristments"])) {
                this.adveristments = [] as any;
                for (let item of data["adveristments"])
                    this.adveristments!.push(DTOAdvertisement.fromJS(item));
            }
            this.totalResultsCount = data["totalResultsCount"] !== undefined ? data["totalResultsCount"] : <any>null;
            this.regionShortName = data["regionShortName"] !== undefined ? data["regionShortName"] : <any>null;
            this.subRegionName = data["subRegionName"] !== undefined ? data["subRegionName"] : <any>null;
            this.closestSubregionNameIfNoResult = data["closestSubregionNameIfNoResult"] !== undefined ? data["closestSubregionNameIfNoResult"] : <any>null;
        }
    }

    static fromJS(data: any): AdveristmentGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.adveristments)) {
            data["adveristments"] = [];
            for (let item of this.adveristments)
                data["adveristments"].push(item.toJSON());
        }
        data["totalResultsCount"] = this.totalResultsCount !== undefined ? this.totalResultsCount : <any>null;
        data["regionShortName"] = this.regionShortName !== undefined ? this.regionShortName : <any>null;
        data["subRegionName"] = this.subRegionName !== undefined ? this.subRegionName : <any>null;
        data["closestSubregionNameIfNoResult"] = this.closestSubregionNameIfNoResult !== undefined ? this.closestSubregionNameIfNoResult : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdveristmentGetResponse {
        const json = this.toJSON();
        let result = new AdveristmentGetResponse();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentGetResponse extends IResponseBaseModel {
    adveristments?: DTOAdvertisement[] | null;
    totalResultsCount: number;
    regionShortName?: string | null;
    subRegionName?: string | null;
    closestSubregionNameIfNoResult?: string | null;
}

export class AdveristmentGetModel implements IAdveristmentGetModel {
    conversationKey?: string | null;
    byId?: number | null;
    userId?: number | null;
    pageNumber?: number | null;
    pageSize?: number | null;
    nonDemoOnly?: boolean | null;
    regionId?: number | null;
    subRegionId?: number | null;
    zipCode?: string | null;
    miles?: number | null;
    keywords?: string | null;
    withPicturesOnly?: boolean | null;
    showActive?: boolean | null;
    showExpired?: boolean | null;
    casualDating?: boolean | null;
    advertisementCategoryId?: number | null;
    title?: string | null;
    content?: string | null;
    manageId?: string | null;
    age?: string | null;
    locationDescription?: string | null;

    constructor(data?: IAdveristmentGetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.conversationKey = data["conversationKey"] !== undefined ? data["conversationKey"] : <any>null;
            this.byId = data["byId"] !== undefined ? data["byId"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.pageNumber = data["pageNumber"] !== undefined ? data["pageNumber"] : <any>null;
            this.pageSize = data["pageSize"] !== undefined ? data["pageSize"] : <any>null;
            this.nonDemoOnly = data["nonDemoOnly"] !== undefined ? data["nonDemoOnly"] : <any>null;
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : <any>null;
            this.subRegionId = data["subRegionId"] !== undefined ? data["subRegionId"] : <any>null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : <any>null;
            this.miles = data["miles"] !== undefined ? data["miles"] : <any>null;
            this.keywords = data["keywords"] !== undefined ? data["keywords"] : <any>null;
            this.withPicturesOnly = data["withPicturesOnly"] !== undefined ? data["withPicturesOnly"] : <any>null;
            this.showActive = data["showActive"] !== undefined ? data["showActive"] : <any>null;
            this.showExpired = data["showExpired"] !== undefined ? data["showExpired"] : <any>null;
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : <any>null;
            this.advertisementCategoryId = data["advertisementCategoryId"] !== undefined ? data["advertisementCategoryId"] : <any>null;
            this.title = data["title"] !== undefined ? data["title"] : <any>null;
            this.content = data["content"] !== undefined ? data["content"] : <any>null;
            this.manageId = data["manageId"] !== undefined ? data["manageId"] : <any>null;
            this.age = data["age"] !== undefined ? data["age"] : <any>null;
            this.locationDescription = data["locationDescription"] !== undefined ? data["locationDescription"] : <any>null;
        }
    }

    static fromJS(data: any): AdveristmentGetModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdveristmentGetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : <any>null;
        data["byId"] = this.byId !== undefined ? this.byId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["nonDemoOnly"] = this.nonDemoOnly !== undefined ? this.nonDemoOnly : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["miles"] = this.miles !== undefined ? this.miles : <any>null;
        data["keywords"] = this.keywords !== undefined ? this.keywords : <any>null;
        data["withPicturesOnly"] = this.withPicturesOnly !== undefined ? this.withPicturesOnly : <any>null;
        data["showActive"] = this.showActive !== undefined ? this.showActive : <any>null;
        data["showExpired"] = this.showExpired !== undefined ? this.showExpired : <any>null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : <any>null;
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["manageId"] = this.manageId !== undefined ? this.manageId : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["locationDescription"] = this.locationDescription !== undefined ? this.locationDescription : <any>null;
        return data; 
    }

    clone(): AdveristmentGetModel {
        const json = this.toJSON();
        let result = new AdveristmentGetModel();
        result.init(json);
        return result;
    }
}

export interface IAdveristmentGetModel {
    conversationKey?: string | null;
    byId?: number | null;
    userId?: number | null;
    pageNumber?: number | null;
    pageSize?: number | null;
    nonDemoOnly?: boolean | null;
    regionId?: number | null;
    subRegionId?: number | null;
    zipCode?: string | null;
    miles?: number | null;
    keywords?: string | null;
    withPicturesOnly?: boolean | null;
    showActive?: boolean | null;
    showExpired?: boolean | null;
    casualDating?: boolean | null;
    advertisementCategoryId?: number | null;
    title?: string | null;
    content?: string | null;
    manageId?: string | null;
    age?: string | null;
    locationDescription?: string | null;
}

export class GetAdvertisementsRequest implements IGetAdvertisementsRequest {
    casualDating?: string | null;
    relationShip?: string | null;
    withPicture?: string | null;
    state?: string | null;
    city?: string | null;
    page?: string | null;

    constructor(data?: IGetAdvertisementsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : <any>null;
            this.relationShip = data["relationShip"] !== undefined ? data["relationShip"] : <any>null;
            this.withPicture = data["withPicture"] !== undefined ? data["withPicture"] : <any>null;
            this.state = data["state"] !== undefined ? data["state"] : <any>null;
            this.city = data["city"] !== undefined ? data["city"] : <any>null;
            this.page = data["page"] !== undefined ? data["page"] : <any>null;
        }
    }

    static fromJS(data: any): GetAdvertisementsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvertisementsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : <any>null;
        data["relationShip"] = this.relationShip !== undefined ? this.relationShip : <any>null;
        data["withPicture"] = this.withPicture !== undefined ? this.withPicture : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["page"] = this.page !== undefined ? this.page : <any>null;
        return data; 
    }

    clone(): GetAdvertisementsRequest {
        const json = this.toJSON();
        let result = new GetAdvertisementsRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAdvertisementsRequest {
    casualDating?: string | null;
    relationShip?: string | null;
    withPicture?: string | null;
    state?: string | null;
    city?: string | null;
    page?: string | null;
}

export class SearchParamsResponse implements ISearchParamsResponse {
    regionId!: number;
    subregionId!: number;
    categoryId!: number;
    casualDating!: boolean;
    withPicture!: boolean;
    isValid!: boolean;

    constructor(data?: ISearchParamsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : <any>null;
            this.subregionId = data["subregionId"] !== undefined ? data["subregionId"] : <any>null;
            this.categoryId = data["categoryId"] !== undefined ? data["categoryId"] : <any>null;
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : <any>null;
            this.withPicture = data["withPicture"] !== undefined ? data["withPicture"] : <any>null;
            this.isValid = data["isValid"] !== undefined ? data["isValid"] : <any>null;
        }
    }

    static fromJS(data: any): SearchParamsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["subregionId"] = this.subregionId !== undefined ? this.subregionId : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : <any>null;
        data["withPicture"] = this.withPicture !== undefined ? this.withPicture : <any>null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        return data; 
    }

    clone(): SearchParamsResponse {
        const json = this.toJSON();
        let result = new SearchParamsResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchParamsResponse {
    regionId: number;
    subregionId: number;
    categoryId: number;
    casualDating: boolean;
    withPicture: boolean;
    isValid: boolean;
}

export class SearchParamsRequest implements ISearchParamsRequest {
    state?: string | null;
    city?: string | null;
    category?: string | null;
    type?: string | null;
    withPicture?: string | null;

    constructor(data?: ISearchParamsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"] !== undefined ? data["state"] : <any>null;
            this.city = data["city"] !== undefined ? data["city"] : <any>null;
            this.category = data["category"] !== undefined ? data["category"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.withPicture = data["withPicture"] !== undefined ? data["withPicture"] : <any>null;
        }
    }

    static fromJS(data: any): SearchParamsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["withPicture"] = this.withPicture !== undefined ? this.withPicture : <any>null;
        return data; 
    }

    clone(): SearchParamsRequest {
        const json = this.toJSON();
        let result = new SearchParamsRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchParamsRequest {
    state?: string | null;
    city?: string | null;
    category?: string | null;
    type?: string | null;
    withPicture?: string | null;
}

export class AdWritterInformationResponse extends ResponseBaseModel implements IAdWritterInformationResponse {
    isSend!: boolean;

    constructor(data?: IAdWritterInformationResponse) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.isSend = data["isSend"] !== undefined ? data["isSend"] : <any>null;
        }
    }

    static fromJS(data: any): AdWritterInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdWritterInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSend"] = this.isSend !== undefined ? this.isSend : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdWritterInformationResponse {
        const json = this.toJSON();
        let result = new AdWritterInformationResponse();
        result.init(json);
        return result;
    }
}

export interface IAdWritterInformationResponse extends IResponseBaseModel {
    isSend: boolean;
}

export class AdWritterInformationRequest implements IAdWritterInformationRequest {
    name?: string | null;
    age?: string | null;
    gender?: string | null;
    lookingFor?: string | null;
    height?: string | null;
    weight?: string | null;
    bodyType?: string | null;
    race?: string | null;
    idealMatch?: string | null;
    lookingForRelationship?: string | null;
    thingsInFreeTime?: string | null;
    aspectsOfLife?: string | null;
    dontLike?: string | null;
    passions?: string | null;
    occupation?: string | null;
    characteristics?: string | null;
    goalsAndDreams?: string | null;
    thankfullFor?: string | null;
    kids?: string | null;
    education?: string | null;
    workout?: string | null;
    travel?: string | null;
    healthyFood?: string | null;
    smoke?: string | null;
    alcohol?: string | null;
    email?: string | null;

    constructor(data?: IAdWritterInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.age = data["age"] !== undefined ? data["age"] : <any>null;
            this.gender = data["gender"] !== undefined ? data["gender"] : <any>null;
            this.lookingFor = data["lookingFor"] !== undefined ? data["lookingFor"] : <any>null;
            this.height = data["height"] !== undefined ? data["height"] : <any>null;
            this.weight = data["weight"] !== undefined ? data["weight"] : <any>null;
            this.bodyType = data["bodyType"] !== undefined ? data["bodyType"] : <any>null;
            this.race = data["race"] !== undefined ? data["race"] : <any>null;
            this.idealMatch = data["idealMatch"] !== undefined ? data["idealMatch"] : <any>null;
            this.lookingForRelationship = data["lookingForRelationship"] !== undefined ? data["lookingForRelationship"] : <any>null;
            this.thingsInFreeTime = data["thingsInFreeTime"] !== undefined ? data["thingsInFreeTime"] : <any>null;
            this.aspectsOfLife = data["aspectsOfLife"] !== undefined ? data["aspectsOfLife"] : <any>null;
            this.dontLike = data["dontLike"] !== undefined ? data["dontLike"] : <any>null;
            this.passions = data["passions"] !== undefined ? data["passions"] : <any>null;
            this.occupation = data["occupation"] !== undefined ? data["occupation"] : <any>null;
            this.characteristics = data["characteristics"] !== undefined ? data["characteristics"] : <any>null;
            this.goalsAndDreams = data["goalsAndDreams"] !== undefined ? data["goalsAndDreams"] : <any>null;
            this.thankfullFor = data["thankfullFor"] !== undefined ? data["thankfullFor"] : <any>null;
            this.kids = data["kids"] !== undefined ? data["kids"] : <any>null;
            this.education = data["education"] !== undefined ? data["education"] : <any>null;
            this.workout = data["workout"] !== undefined ? data["workout"] : <any>null;
            this.travel = data["travel"] !== undefined ? data["travel"] : <any>null;
            this.healthyFood = data["healthyFood"] !== undefined ? data["healthyFood"] : <any>null;
            this.smoke = data["smoke"] !== undefined ? data["smoke"] : <any>null;
            this.alcohol = data["alcohol"] !== undefined ? data["alcohol"] : <any>null;
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
        }
    }

    static fromJS(data: any): AdWritterInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdWritterInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["lookingFor"] = this.lookingFor !== undefined ? this.lookingFor : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        data["bodyType"] = this.bodyType !== undefined ? this.bodyType : <any>null;
        data["race"] = this.race !== undefined ? this.race : <any>null;
        data["idealMatch"] = this.idealMatch !== undefined ? this.idealMatch : <any>null;
        data["lookingForRelationship"] = this.lookingForRelationship !== undefined ? this.lookingForRelationship : <any>null;
        data["thingsInFreeTime"] = this.thingsInFreeTime !== undefined ? this.thingsInFreeTime : <any>null;
        data["aspectsOfLife"] = this.aspectsOfLife !== undefined ? this.aspectsOfLife : <any>null;
        data["dontLike"] = this.dontLike !== undefined ? this.dontLike : <any>null;
        data["passions"] = this.passions !== undefined ? this.passions : <any>null;
        data["occupation"] = this.occupation !== undefined ? this.occupation : <any>null;
        data["characteristics"] = this.characteristics !== undefined ? this.characteristics : <any>null;
        data["goalsAndDreams"] = this.goalsAndDreams !== undefined ? this.goalsAndDreams : <any>null;
        data["thankfullFor"] = this.thankfullFor !== undefined ? this.thankfullFor : <any>null;
        data["kids"] = this.kids !== undefined ? this.kids : <any>null;
        data["education"] = this.education !== undefined ? this.education : <any>null;
        data["workout"] = this.workout !== undefined ? this.workout : <any>null;
        data["travel"] = this.travel !== undefined ? this.travel : <any>null;
        data["healthyFood"] = this.healthyFood !== undefined ? this.healthyFood : <any>null;
        data["smoke"] = this.smoke !== undefined ? this.smoke : <any>null;
        data["alcohol"] = this.alcohol !== undefined ? this.alcohol : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data; 
    }

    clone(): AdWritterInformationRequest {
        const json = this.toJSON();
        let result = new AdWritterInformationRequest();
        result.init(json);
        return result;
    }
}

export interface IAdWritterInformationRequest {
    name?: string | null;
    age?: string | null;
    gender?: string | null;
    lookingFor?: string | null;
    height?: string | null;
    weight?: string | null;
    bodyType?: string | null;
    race?: string | null;
    idealMatch?: string | null;
    lookingForRelationship?: string | null;
    thingsInFreeTime?: string | null;
    aspectsOfLife?: string | null;
    dontLike?: string | null;
    passions?: string | null;
    occupation?: string | null;
    characteristics?: string | null;
    goalsAndDreams?: string | null;
    thankfullFor?: string | null;
    kids?: string | null;
    education?: string | null;
    workout?: string | null;
    travel?: string | null;
    healthyFood?: string | null;
    smoke?: string | null;
    alcohol?: string | null;
    email?: string | null;
}

export class LoginResponseModel extends ResponseBaseModel implements ILoginResponseModel {
    token?: string | null;
    isDemo!: boolean;
    phoneVerificationRequired!: boolean;
    userId!: number;
    userPhone?: string | null;

    constructor(data?: ILoginResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.token = data["token"] !== undefined ? data["token"] : <any>null;
            this.isDemo = data["isDemo"] !== undefined ? data["isDemo"] : <any>null;
            this.phoneVerificationRequired = data["phoneVerificationRequired"] !== undefined ? data["phoneVerificationRequired"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.userPhone = data["userPhone"] !== undefined ? data["userPhone"] : <any>null;
        }
    }

    static fromJS(data: any): LoginResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : <any>null;
        data["phoneVerificationRequired"] = this.phoneVerificationRequired !== undefined ? this.phoneVerificationRequired : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["userPhone"] = this.userPhone !== undefined ? this.userPhone : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): LoginResponseModel {
        const json = this.toJSON();
        let result = new LoginResponseModel();
        result.init(json);
        return result;
    }
}

export interface ILoginResponseModel extends IResponseBaseModel {
    token?: string | null;
    isDemo: boolean;
    phoneVerificationRequired: boolean;
    userId: number;
    userPhone?: string | null;
}

export class LoginModel implements ILoginModel {
    userName?: string | null;
    password?: string | null;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"] !== undefined ? data["userName"] : <any>null;
            this.password = data["password"] !== undefined ? data["password"] : <any>null;
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data; 
    }

    clone(): LoginModel {
        const json = this.toJSON();
        let result = new LoginModel();
        result.init(json);
        return result;
    }
}

export interface ILoginModel {
    userName?: string | null;
    password?: string | null;
}

export class Baners implements IBaners {
    banerId!: number;
    createdAt!: moment.Moment;
    clientDetails?: string | null;
    banerUrl?: string | null;
    desktopImageHorizontal?: string | null;
    desktopImageVertical?: string | null;
    mobileImage?: string | null;
    isMobile!: number;
    status!: BanerStatus;

    constructor(data?: IBaners) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.status = BanerStatus.Active;
        }
    }

    init(data?: any) {
        if (data) {
            this.banerId = data["banerId"] !== undefined ? data["banerId"] : <any>null;
            this.createdAt = data["createdAt"] ? moment(data["createdAt"].toString()) : <any>null;
            this.clientDetails = data["clientDetails"] !== undefined ? data["clientDetails"] : <any>null;
            this.banerUrl = data["banerUrl"] !== undefined ? data["banerUrl"] : <any>null;
            this.desktopImageHorizontal = data["desktopImageHorizontal"] !== undefined ? data["desktopImageHorizontal"] : <any>null;
            this.desktopImageVertical = data["desktopImageVertical"] !== undefined ? data["desktopImageVertical"] : <any>null;
            this.mobileImage = data["mobileImage"] !== undefined ? data["mobileImage"] : <any>null;
            this.isMobile = data["isMobile"] !== undefined ? data["isMobile"] : <any>null;
            this.status = data["status"] !== undefined ? data["status"] : BanerStatus.Active;
        }
    }

    static fromJS(data: any): Baners {
        data = typeof data === 'object' ? data : {};
        let result = new Baners();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["banerId"] = this.banerId !== undefined ? this.banerId : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["clientDetails"] = this.clientDetails !== undefined ? this.clientDetails : <any>null;
        data["banerUrl"] = this.banerUrl !== undefined ? this.banerUrl : <any>null;
        data["desktopImageHorizontal"] = this.desktopImageHorizontal !== undefined ? this.desktopImageHorizontal : <any>null;
        data["desktopImageVertical"] = this.desktopImageVertical !== undefined ? this.desktopImageVertical : <any>null;
        data["mobileImage"] = this.mobileImage !== undefined ? this.mobileImage : <any>null;
        data["isMobile"] = this.isMobile !== undefined ? this.isMobile : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data; 
    }

    clone(): Baners {
        const json = this.toJSON();
        let result = new Baners();
        result.init(json);
        return result;
    }
}

export interface IBaners {
    banerId: number;
    createdAt: moment.Moment;
    clientDetails?: string | null;
    banerUrl?: string | null;
    desktopImageHorizontal?: string | null;
    desktopImageVertical?: string | null;
    mobileImage?: string | null;
    isMobile: number;
    status: BanerStatus;
}

export enum BanerStatus {
    Active = 0,
    Canceled = 1,
    Expired = 2,
}

export class ConversationDeleteResponseModel extends ResponseBaseModel implements IConversationDeleteResponseModel {

    constructor(data?: IConversationDeleteResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): ConversationDeleteResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationDeleteResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): ConversationDeleteResponseModel {
        const json = this.toJSON();
        let result = new ConversationDeleteResponseModel();
        result.init(json);
        return result;
    }
}

export interface IConversationDeleteResponseModel extends IResponseBaseModel {
}

export class ConversationDeleteRequestModel implements IConversationDeleteRequestModel {
    conversationId!: number;

    constructor(data?: IConversationDeleteRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.conversationId = data["conversationId"] !== undefined ? data["conversationId"] : <any>null;
        }
    }

    static fromJS(data: any): ConversationDeleteRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationDeleteRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : <any>null;
        return data; 
    }

    clone(): ConversationDeleteRequestModel {
        const json = this.toJSON();
        let result = new ConversationDeleteRequestModel();
        result.init(json);
        return result;
    }
}

export interface IConversationDeleteRequestModel {
    conversationId: number;
}

export class GetConversationResponseModel extends ResponseBaseModel implements IGetConversationResponseModel {
    conversation?: DTOConversation | null;

    constructor(data?: IGetConversationResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.conversation = data["conversation"] ? DTOConversation.fromJS(data["conversation"]) : <any>null;
        }
    }

    static fromJS(data: any): GetConversationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversation"] = this.conversation ? this.conversation.toJSON() : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): GetConversationResponseModel {
        const json = this.toJSON();
        let result = new GetConversationResponseModel();
        result.init(json);
        return result;
    }
}

export interface IGetConversationResponseModel extends IResponseBaseModel {
    conversation?: DTOConversation | null;
}

export class DTOConversation implements IDTOConversation {
    conversationId!: number;
    senderId!: number;
    receiverId!: number;
    conversationKey?: string | null;
    senderNick?: string | null;
    creationDate!: moment.Moment;
    receiverNick?: string | null;
    advTitle?: string | null;
    advertisementId!: number;
    demoAdvertisement!: boolean;
    hasNewMessages!: boolean;
    lastMessageDate!: moment.Moment;
    messages?: DTOConversationMessage[] | null;

    constructor(data?: IDTOConversation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.conversationId = data["conversationId"] !== undefined ? data["conversationId"] : <any>null;
            this.senderId = data["senderId"] !== undefined ? data["senderId"] : <any>null;
            this.receiverId = data["receiverId"] !== undefined ? data["receiverId"] : <any>null;
            this.conversationKey = data["conversationKey"] !== undefined ? data["conversationKey"] : <any>null;
            this.senderNick = data["senderNick"] !== undefined ? data["senderNick"] : <any>null;
            this.creationDate = data["creationDate"] ? moment(data["creationDate"].toString()) : <any>null;
            this.receiverNick = data["receiverNick"] !== undefined ? data["receiverNick"] : <any>null;
            this.advTitle = data["advTitle"] !== undefined ? data["advTitle"] : <any>null;
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : <any>null;
            this.demoAdvertisement = data["demoAdvertisement"] !== undefined ? data["demoAdvertisement"] : <any>null;
            this.hasNewMessages = data["hasNewMessages"] !== undefined ? data["hasNewMessages"] : <any>null;
            this.lastMessageDate = data["lastMessageDate"] ? moment(data["lastMessageDate"].toString()) : <any>null;
            if (Array.isArray(data["messages"])) {
                this.messages = [] as any;
                for (let item of data["messages"])
                    this.messages!.push(DTOConversationMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DTOConversation {
        data = typeof data === 'object' ? data : {};
        let result = new DTOConversation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : <any>null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : <any>null;
        data["receiverId"] = this.receiverId !== undefined ? this.receiverId : <any>null;
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : <any>null;
        data["senderNick"] = this.senderNick !== undefined ? this.senderNick : <any>null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>null;
        data["receiverNick"] = this.receiverNick !== undefined ? this.receiverNick : <any>null;
        data["advTitle"] = this.advTitle !== undefined ? this.advTitle : <any>null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["demoAdvertisement"] = this.demoAdvertisement !== undefined ? this.demoAdvertisement : <any>null;
        data["hasNewMessages"] = this.hasNewMessages !== undefined ? this.hasNewMessages : <any>null;
        data["lastMessageDate"] = this.lastMessageDate ? this.lastMessageDate.toISOString() : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DTOConversation {
        const json = this.toJSON();
        let result = new DTOConversation();
        result.init(json);
        return result;
    }
}

export interface IDTOConversation {
    conversationId: number;
    senderId: number;
    receiverId: number;
    conversationKey?: string | null;
    senderNick?: string | null;
    creationDate: moment.Moment;
    receiverNick?: string | null;
    advTitle?: string | null;
    advertisementId: number;
    demoAdvertisement: boolean;
    hasNewMessages: boolean;
    lastMessageDate: moment.Moment;
    messages?: DTOConversationMessage[] | null;
}

export class DTOConversationMessage implements IDTOConversationMessage {
    conversationMessageId!: number;
    content?: string | null;
    senderId!: number;
    creationDate!: moment.Moment;
    title?: string | null;
    isRead!: boolean;
    images?: DTOConversationImage[] | null;

    constructor(data?: IDTOConversationMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.conversationMessageId = data["conversationMessageId"] !== undefined ? data["conversationMessageId"] : <any>null;
            this.content = data["content"] !== undefined ? data["content"] : <any>null;
            this.senderId = data["senderId"] !== undefined ? data["senderId"] : <any>null;
            this.creationDate = data["creationDate"] ? moment(data["creationDate"].toString()) : <any>null;
            this.title = data["title"] !== undefined ? data["title"] : <any>null;
            this.isRead = data["isRead"] !== undefined ? data["isRead"] : <any>null;
            if (Array.isArray(data["images"])) {
                this.images = [] as any;
                for (let item of data["images"])
                    this.images!.push(DTOConversationImage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DTOConversationMessage {
        data = typeof data === 'object' ? data : {};
        let result = new DTOConversationMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationMessageId"] = this.conversationMessageId !== undefined ? this.conversationMessageId : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : <any>null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["isRead"] = this.isRead !== undefined ? this.isRead : <any>null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DTOConversationMessage {
        const json = this.toJSON();
        let result = new DTOConversationMessage();
        result.init(json);
        return result;
    }
}

export interface IDTOConversationMessage {
    conversationMessageId: number;
    content?: string | null;
    senderId: number;
    creationDate: moment.Moment;
    title?: string | null;
    isRead: boolean;
    images?: DTOConversationImage[] | null;
}

export class DTOConversationImage implements IDTOConversationImage {
    conversationImageId!: number;
    name?: string | null;
    fileName?: string | null;

    constructor(data?: IDTOConversationImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.conversationImageId = data["conversationImageId"] !== undefined ? data["conversationImageId"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): DTOConversationImage {
        data = typeof data === 'object' ? data : {};
        let result = new DTOConversationImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationImageId"] = this.conversationImageId !== undefined ? this.conversationImageId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data; 
    }

    clone(): DTOConversationImage {
        const json = this.toJSON();
        let result = new DTOConversationImage();
        result.init(json);
        return result;
    }
}

export interface IDTOConversationImage {
    conversationImageId: number;
    name?: string | null;
    fileName?: string | null;
}

export class UserConversationsResponseModel extends ResponseBaseModel implements IUserConversationsResponseModel {
    conversations?: DTOConversation[] | null;
    unreadMessagesCount!: number;
    page!: number;
    pageSize!: number;
    pageCount!: number;

    constructor(data?: IUserConversationsResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["conversations"])) {
                this.conversations = [] as any;
                for (let item of data["conversations"])
                    this.conversations!.push(DTOConversation.fromJS(item));
            }
            this.unreadMessagesCount = data["unreadMessagesCount"] !== undefined ? data["unreadMessagesCount"] : <any>null;
            this.page = data["page"] !== undefined ? data["page"] : <any>null;
            this.pageSize = data["pageSize"] !== undefined ? data["pageSize"] : <any>null;
            this.pageCount = data["pageCount"] !== undefined ? data["pageCount"] : <any>null;
        }
    }

    static fromJS(data: any): UserConversationsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserConversationsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conversations)) {
            data["conversations"] = [];
            for (let item of this.conversations)
                data["conversations"].push(item.toJSON());
        }
        data["unreadMessagesCount"] = this.unreadMessagesCount !== undefined ? this.unreadMessagesCount : <any>null;
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): UserConversationsResponseModel {
        const json = this.toJSON();
        let result = new UserConversationsResponseModel();
        result.init(json);
        return result;
    }
}

export interface IUserConversationsResponseModel extends IResponseBaseModel {
    conversations?: DTOConversation[] | null;
    unreadMessagesCount: number;
    page: number;
    pageSize: number;
    pageCount: number;
}

export class UserConversationsRequestModel implements IUserConversationsRequestModel {

    constructor(data?: IUserConversationsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): UserConversationsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserConversationsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): UserConversationsRequestModel {
        const json = this.toJSON();
        let result = new UserConversationsRequestModel();
        result.init(json);
        return result;
    }
}

export interface IUserConversationsRequestModel {
}

export class MessageSubmitResponseModel extends ResponseBaseModel implements IMessageSubmitResponseModel {
    conversationKey?: string | null;
    unreadMessagesCount!: number;
    page!: number;
    pageSize!: number;
    pageCount!: number;

    constructor(data?: IMessageSubmitResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.conversationKey = data["conversationKey"] !== undefined ? data["conversationKey"] : <any>null;
            this.unreadMessagesCount = data["unreadMessagesCount"] !== undefined ? data["unreadMessagesCount"] : <any>null;
            this.page = data["page"] !== undefined ? data["page"] : <any>null;
            this.pageSize = data["pageSize"] !== undefined ? data["pageSize"] : <any>null;
            this.pageCount = data["pageCount"] !== undefined ? data["pageCount"] : <any>null;
        }
    }

    static fromJS(data: any): MessageSubmitResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSubmitResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : <any>null;
        data["unreadMessagesCount"] = this.unreadMessagesCount !== undefined ? this.unreadMessagesCount : <any>null;
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): MessageSubmitResponseModel {
        const json = this.toJSON();
        let result = new MessageSubmitResponseModel();
        result.init(json);
        return result;
    }
}

export interface IMessageSubmitResponseModel extends IResponseBaseModel {
    conversationKey?: string | null;
    unreadMessagesCount: number;
    page: number;
    pageSize: number;
    pageCount: number;
}

export class BaseMessageSubmitRequestModel implements IBaseMessageSubmitRequestModel {
    images?: DTOImage[] | null;
    content?: string | null;

    constructor(data?: IBaseMessageSubmitRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["images"])) {
                this.images = [] as any;
                for (let item of data["images"])
                    this.images!.push(DTOImage.fromJS(item));
            }
            this.content = data["content"] !== undefined ? data["content"] : <any>null;
        }
    }

    static fromJS(data: any): BaseMessageSubmitRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseMessageSubmitRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["content"] = this.content !== undefined ? this.content : <any>null;
        return data; 
    }

    clone(): BaseMessageSubmitRequestModel {
        const json = this.toJSON();
        let result = new BaseMessageSubmitRequestModel();
        result.init(json);
        return result;
    }
}

export interface IBaseMessageSubmitRequestModel {
    images?: DTOImage[] | null;
    content?: string | null;
}

export class ConversationMessageSubmitRequestModel extends BaseMessageSubmitRequestModel implements IConversationMessageSubmitRequestModel {
    conversationId!: number;
    senderId!: number;

    constructor(data?: IConversationMessageSubmitRequestModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.conversationId = data["conversationId"] !== undefined ? data["conversationId"] : <any>null;
            this.senderId = data["senderId"] !== undefined ? data["senderId"] : <any>null;
        }
    }

    static fromJS(data: any): ConversationMessageSubmitRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationMessageSubmitRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : <any>null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): ConversationMessageSubmitRequestModel {
        const json = this.toJSON();
        let result = new ConversationMessageSubmitRequestModel();
        result.init(json);
        return result;
    }
}

export interface IConversationMessageSubmitRequestModel extends IBaseMessageSubmitRequestModel {
    conversationId: number;
    senderId: number;
}

export class DTOImage extends DTOBaseModel implements IDTOImage {
    fileName?: string | null;
    orgFileName?: string | null;

    constructor(data?: IDTOImage) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : <any>null;
            this.orgFileName = data["orgFileName"] !== undefined ? data["orgFileName"] : <any>null;
        }
    }

    static fromJS(data: any): DTOImage {
        data = typeof data === 'object' ? data : {};
        let result = new DTOImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["orgFileName"] = this.orgFileName !== undefined ? this.orgFileName : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): DTOImage {
        const json = this.toJSON();
        let result = new DTOImage();
        result.init(json);
        return result;
    }
}

export interface IDTOImage extends IDTOBaseModel {
    fileName?: string | null;
    orgFileName?: string | null;
}

export class StartConversationMessageSubmitRequestModel extends BaseMessageSubmitRequestModel implements IStartConversationMessageSubmitRequestModel {
    receiverId!: number;
    senderId!: number;
    senderNick?: string | null;
    advertisementId!: number;
    additionalInformations?: ConversationAdditionalInformations | null;

    constructor(data?: IStartConversationMessageSubmitRequestModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.receiverId = data["receiverId"] !== undefined ? data["receiverId"] : <any>null;
            this.senderId = data["senderId"] !== undefined ? data["senderId"] : <any>null;
            this.senderNick = data["senderNick"] !== undefined ? data["senderNick"] : <any>null;
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : <any>null;
            this.additionalInformations = data["additionalInformations"] ? ConversationAdditionalInformations.fromJS(data["additionalInformations"]) : <any>null;
        }
    }

    static fromJS(data: any): StartConversationMessageSubmitRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new StartConversationMessageSubmitRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiverId"] = this.receiverId !== undefined ? this.receiverId : <any>null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : <any>null;
        data["senderNick"] = this.senderNick !== undefined ? this.senderNick : <any>null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["additionalInformations"] = this.additionalInformations ? this.additionalInformations.toJSON() : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): StartConversationMessageSubmitRequestModel {
        const json = this.toJSON();
        let result = new StartConversationMessageSubmitRequestModel();
        result.init(json);
        return result;
    }
}

export interface IStartConversationMessageSubmitRequestModel extends IBaseMessageSubmitRequestModel {
    receiverId: number;
    senderId: number;
    senderNick?: string | null;
    advertisementId: number;
    additionalInformations?: ConversationAdditionalInformations | null;
}

export class ConversationAdditionalInformations implements IConversationAdditionalInformations {
    advertisementData?: moment.Moment | null;
    subregionName?: string | null;
    regionShortName?: string | null;

    constructor(data?: IConversationAdditionalInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.advertisementData = data["advertisementData"] ? moment(data["advertisementData"].toString()) : <any>null;
            this.subregionName = data["subregionName"] !== undefined ? data["subregionName"] : <any>null;
            this.regionShortName = data["regionShortName"] !== undefined ? data["regionShortName"] : <any>null;
        }
    }

    static fromJS(data: any): ConversationAdditionalInformations {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationAdditionalInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementData"] = this.advertisementData ? this.advertisementData.toISOString() : <any>null;
        data["subregionName"] = this.subregionName !== undefined ? this.subregionName : <any>null;
        data["regionShortName"] = this.regionShortName !== undefined ? this.regionShortName : <any>null;
        return data; 
    }

    clone(): ConversationAdditionalInformations {
        const json = this.toJSON();
        let result = new ConversationAdditionalInformations();
        result.init(json);
        return result;
    }
}

export interface IConversationAdditionalInformations {
    advertisementData?: moment.Moment | null;
    subregionName?: string | null;
    regionShortName?: string | null;
}

export class EmojiResponseModel extends ResponseBaseModel implements IEmojiResponseModel {
    emojis?: DTOEmoji[] | null;

    constructor(data?: IEmojiResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["emojis"])) {
                this.emojis = [] as any;
                for (let item of data["emojis"])
                    this.emojis!.push(DTOEmoji.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmojiResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmojiResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emojis)) {
            data["emojis"] = [];
            for (let item of this.emojis)
                data["emojis"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EmojiResponseModel {
        const json = this.toJSON();
        let result = new EmojiResponseModel();
        result.init(json);
        return result;
    }
}

export interface IEmojiResponseModel extends IResponseBaseModel {
    emojis?: DTOEmoji[] | null;
}

export class DTOEmoji implements IDTOEmoji {
    emojiId!: number;
    code?: string | null;
    title?: string | null;
    category?: string | null;

    constructor(data?: IDTOEmoji) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emojiId = data["emojiId"] !== undefined ? data["emojiId"] : <any>null;
            this.code = data["code"] !== undefined ? data["code"] : <any>null;
            this.title = data["title"] !== undefined ? data["title"] : <any>null;
            this.category = data["category"] !== undefined ? data["category"] : <any>null;
        }
    }

    static fromJS(data: any): DTOEmoji {
        data = typeof data === 'object' ? data : {};
        let result = new DTOEmoji();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emojiId"] = this.emojiId !== undefined ? this.emojiId : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        return data; 
    }

    clone(): DTOEmoji {
        const json = this.toJSON();
        let result = new DTOEmoji();
        result.init(json);
        return result;
    }
}

export interface IDTOEmoji {
    emojiId: number;
    code?: string | null;
    title?: string | null;
    category?: string | null;
}

export class BaseModel implements IBaseModel {
    createdAt!: moment.Moment;
    updatedAt!: moment.Moment;
    createdById!: number;
    updatedById!: number;

    constructor(data?: IBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createdAt = data["createdAt"] ? moment(data["createdAt"].toString()) : <any>null;
            this.updatedAt = data["updatedAt"] ? moment(data["updatedAt"].toString()) : <any>null;
            this.createdById = data["createdById"] !== undefined ? data["createdById"] : <any>null;
            this.updatedById = data["updatedById"] !== undefined ? data["updatedById"] : <any>null;
        }
    }

    static fromJS(data: any): BaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["createdById"] = this.createdById !== undefined ? this.createdById : <any>null;
        data["updatedById"] = this.updatedById !== undefined ? this.updatedById : <any>null;
        return data; 
    }

    clone(): BaseModel {
        const json = this.toJSON();
        let result = new BaseModel();
        result.init(json);
        return result;
    }
}

export interface IBaseModel {
    createdAt: moment.Moment;
    updatedAt: moment.Moment;
    createdById: number;
    updatedById: number;
}

export class SubRegion extends BaseModel implements ISubRegion {
    subRegionId!: number;
    name!: string;
    zip?: string | null;
    latitude!: number;
    longitude!: number;
    isActive!: boolean;
    regionId!: number;
    demoQuantityRatio!: number;
    population!: number;
    region?: Region | null;
    advertisements?: Advertisement[] | null;

    constructor(data?: ISubRegion) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.subRegionId = data["subRegionId"] !== undefined ? data["subRegionId"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.zip = data["zip"] !== undefined ? data["zip"] : <any>null;
            this.latitude = data["latitude"] !== undefined ? data["latitude"] : <any>null;
            this.longitude = data["longitude"] !== undefined ? data["longitude"] : <any>null;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : <any>null;
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : <any>null;
            this.demoQuantityRatio = data["demoQuantityRatio"] !== undefined ? data["demoQuantityRatio"] : <any>null;
            this.population = data["population"] !== undefined ? data["population"] : <any>null;
            this.region = data["region"] ? Region.fromJS(data["region"]) : <any>null;
            if (Array.isArray(data["advertisements"])) {
                this.advertisements = [] as any;
                for (let item of data["advertisements"])
                    this.advertisements!.push(Advertisement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubRegion {
        data = typeof data === 'object' ? data : {};
        let result = new SubRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["demoQuantityRatio"] = this.demoQuantityRatio !== undefined ? this.demoQuantityRatio : <any>null;
        data["population"] = this.population !== undefined ? this.population : <any>null;
        data["region"] = this.region ? this.region.toJSON() : <any>null;
        if (Array.isArray(this.advertisements)) {
            data["advertisements"] = [];
            for (let item of this.advertisements)
                data["advertisements"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): SubRegion {
        const json = this.toJSON();
        let result = new SubRegion();
        result.init(json);
        return result;
    }
}

export interface ISubRegion extends IBaseModel {
    subRegionId: number;
    name: string;
    zip?: string | null;
    latitude: number;
    longitude: number;
    isActive: boolean;
    regionId: number;
    demoQuantityRatio: number;
    population: number;
    region?: Region | null;
    advertisements?: Advertisement[] | null;
}

export class Region extends BaseModel implements IRegion {
    regionId!: number;
    shortName!: string;
    name!: string;
    isActive!: boolean;
    subRegions?: SubRegion[] | null;
    advertisements?: Advertisement[] | null;

    constructor(data?: IRegion) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : <any>null;
            this.shortName = data["shortName"] !== undefined ? data["shortName"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : <any>null;
            if (Array.isArray(data["subRegions"])) {
                this.subRegions = [] as any;
                for (let item of data["subRegions"])
                    this.subRegions!.push(SubRegion.fromJS(item));
            }
            if (Array.isArray(data["advertisements"])) {
                this.advertisements = [] as any;
                for (let item of data["advertisements"])
                    this.advertisements!.push(Advertisement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Region {
        data = typeof data === 'object' ? data : {};
        let result = new Region();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.subRegions)) {
            data["subRegions"] = [];
            for (let item of this.subRegions)
                data["subRegions"].push(item.toJSON());
        }
        if (Array.isArray(this.advertisements)) {
            data["advertisements"] = [];
            for (let item of this.advertisements)
                data["advertisements"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Region {
        const json = this.toJSON();
        let result = new Region();
        result.init(json);
        return result;
    }
}

export interface IRegion extends IBaseModel {
    regionId: number;
    shortName: string;
    name: string;
    isActive: boolean;
    subRegions?: SubRegion[] | null;
    advertisements?: Advertisement[] | null;
}

export class Advertisement extends BaseModel implements IAdvertisement {
    advertisementId!: number;
    regionId?: number | null;
    subRegionId?: number | null;
    seen!: boolean;
    seenAdmin!: boolean;
    region?: Region | null;
    subRegion?: SubRegion | null;
    zipCode?: string | null;
    location?: Point | null;
    dateStart!: moment.Moment;
    dateEnd?: moment.Moment | null;
    title!: string;
    content?: string | null;
    published!: boolean;
    casualDating!: boolean;
    advertisementCategoryId!: number;
    nick?: string | null;
    category?: AdvertisementCategory | null;
    images?: AdvertisementImage[] | null;
    conversations?: Conversation[] | null;
    userId!: number;
    isDemo!: boolean;
    isPremium!: boolean;
    isThirdParty!: boolean;
    user?: User | null;
    manageId?: string | null;
    moderated!: boolean;
    moderatedAt?: moment.Moment | null;
    moderatedBy?: number | null;
    moderateText?: string | null;
    age?: string | null;
    isExpiredMailSend!: boolean;
    settings?: AdvertisementSetting | null;

    constructor(data?: IAdvertisement) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : <any>null;
            this.regionId = data["regionId"] !== undefined ? data["regionId"] : <any>null;
            this.subRegionId = data["subRegionId"] !== undefined ? data["subRegionId"] : <any>null;
            this.seen = data["seen"] !== undefined ? data["seen"] : <any>null;
            this.seenAdmin = data["seenAdmin"] !== undefined ? data["seenAdmin"] : <any>null;
            this.region = data["region"] ? Region.fromJS(data["region"]) : <any>null;
            this.subRegion = data["subRegion"] ? SubRegion.fromJS(data["subRegion"]) : <any>null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : <any>null;
            this.location = data["location"] ? Point.fromJS(data["location"]) : <any>null;
            this.dateStart = data["dateStart"] ? moment(data["dateStart"].toString()) : <any>null;
            this.dateEnd = data["dateEnd"] ? moment(data["dateEnd"].toString()) : <any>null;
            this.title = data["title"] !== undefined ? data["title"] : <any>null;
            this.content = data["content"] !== undefined ? data["content"] : <any>null;
            this.published = data["published"] !== undefined ? data["published"] : <any>null;
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : <any>null;
            this.advertisementCategoryId = data["advertisementCategoryId"] !== undefined ? data["advertisementCategoryId"] : <any>null;
            this.nick = data["nick"] !== undefined ? data["nick"] : <any>null;
            this.category = data["category"] ? AdvertisementCategory.fromJS(data["category"]) : <any>null;
            if (Array.isArray(data["images"])) {
                this.images = [] as any;
                for (let item of data["images"])
                    this.images!.push(AdvertisementImage.fromJS(item));
            }
            if (Array.isArray(data["conversations"])) {
                this.conversations = [] as any;
                for (let item of data["conversations"])
                    this.conversations!.push(Conversation.fromJS(item));
            }
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.isDemo = data["isDemo"] !== undefined ? data["isDemo"] : <any>null;
            this.isPremium = data["isPremium"] !== undefined ? data["isPremium"] : <any>null;
            this.isThirdParty = data["isThirdParty"] !== undefined ? data["isThirdParty"] : <any>null;
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>null;
            this.manageId = data["manageId"] !== undefined ? data["manageId"] : <any>null;
            this.moderated = data["moderated"] !== undefined ? data["moderated"] : <any>null;
            this.moderatedAt = data["moderatedAt"] ? moment(data["moderatedAt"].toString()) : <any>null;
            this.moderatedBy = data["moderatedBy"] !== undefined ? data["moderatedBy"] : <any>null;
            this.moderateText = data["moderateText"] !== undefined ? data["moderateText"] : <any>null;
            this.age = data["age"] !== undefined ? data["age"] : <any>null;
            this.isExpiredMailSend = data["isExpiredMailSend"] !== undefined ? data["isExpiredMailSend"] : <any>null;
            this.settings = data["settings"] ? AdvertisementSetting.fromJS(data["settings"]) : <any>null;
        }
    }

    static fromJS(data: any): Advertisement {
        data = typeof data === 'object' ? data : {};
        let result = new Advertisement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["regionId"] = this.regionId !== undefined ? this.regionId : <any>null;
        data["subRegionId"] = this.subRegionId !== undefined ? this.subRegionId : <any>null;
        data["seen"] = this.seen !== undefined ? this.seen : <any>null;
        data["seenAdmin"] = this.seenAdmin !== undefined ? this.seenAdmin : <any>null;
        data["region"] = this.region ? this.region.toJSON() : <any>null;
        data["subRegion"] = this.subRegion ? this.subRegion.toJSON() : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["location"] = this.location ? this.location.toJSON() : <any>null;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>null;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["published"] = this.published !== undefined ? this.published : <any>null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : <any>null;
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : <any>null;
        data["nick"] = this.nick !== undefined ? this.nick : <any>null;
        data["category"] = this.category ? this.category.toJSON() : <any>null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.conversations)) {
            data["conversations"] = [];
            for (let item of this.conversations)
                data["conversations"].push(item.toJSON());
        }
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : <any>null;
        data["isPremium"] = this.isPremium !== undefined ? this.isPremium : <any>null;
        data["isThirdParty"] = this.isThirdParty !== undefined ? this.isThirdParty : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["manageId"] = this.manageId !== undefined ? this.manageId : <any>null;
        data["moderated"] = this.moderated !== undefined ? this.moderated : <any>null;
        data["moderatedAt"] = this.moderatedAt ? this.moderatedAt.toISOString() : <any>null;
        data["moderatedBy"] = this.moderatedBy !== undefined ? this.moderatedBy : <any>null;
        data["moderateText"] = this.moderateText !== undefined ? this.moderateText : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["isExpiredMailSend"] = this.isExpiredMailSend !== undefined ? this.isExpiredMailSend : <any>null;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): Advertisement {
        const json = this.toJSON();
        let result = new Advertisement();
        result.init(json);
        return result;
    }
}

export interface IAdvertisement extends IBaseModel {
    advertisementId: number;
    regionId?: number | null;
    subRegionId?: number | null;
    seen: boolean;
    seenAdmin: boolean;
    region?: Region | null;
    subRegion?: SubRegion | null;
    zipCode?: string | null;
    location?: Point | null;
    dateStart: moment.Moment;
    dateEnd?: moment.Moment | null;
    title: string;
    content?: string | null;
    published: boolean;
    casualDating: boolean;
    advertisementCategoryId: number;
    nick?: string | null;
    category?: AdvertisementCategory | null;
    images?: AdvertisementImage[] | null;
    conversations?: Conversation[] | null;
    userId: number;
    isDemo: boolean;
    isPremium: boolean;
    isThirdParty: boolean;
    user?: User | null;
    manageId?: string | null;
    moderated: boolean;
    moderatedAt?: moment.Moment | null;
    moderatedBy?: number | null;
    moderateText?: string | null;
    age?: string | null;
    isExpiredMailSend: boolean;
    settings?: AdvertisementSetting | null;
}

/** A representation of a planar, linear vector geometry. */
export abstract class Geometry implements IGeometry {
    /** Gets the factory which contains the context in which this point was created. */
    factory?: GeometryFactory | null;
    /** Gets/Sets the user data object for this point, if any. */
    userData?: any | null;
    /** Sets the ID of the Spatial Reference System used by the Geometry. */
    srid!: number;
    /** Returns the PrecisionModel used by the Geometry. */
    precisionModel?: PrecisionModel | null;
    /** Returns the number of Geometryes in a GeometryCollection,
or 1, if the geometry is not a collection. */
    numGeometries!: number;
    /** Tests whether this Geometry is simple.

The SFS definition of simplicity
follows the general rule that a Geometry is simple if it has no points of
self-tangency, self-intersection or other anomalous points.

Simplicity is defined for each Geometry subclass as follows:

Valid polygonal geometries are simple, since their rings
must not self-intersect. IsSimple
tests for this condition and reports false if it is not met.
(This is a looser test than checking for validity).
Linear rings have the same semantics.
Linear geometries are simple iff they do not self-intersect at points
other than boundary points.
Zero-dimensional geometries (points) are simple iff they have no
repeated points.
Empty Geometrys are always simple. */
    isSimple!: boolean;
    /** Tests whether this Geometry is topologically
valid, according to the OGC SFS specification.
For validity rules see the documentation for the specific geometry subclass. */
    isValid!: boolean;
    /** Returns the area of this Geometry.
Areal Geometries have a non-zero area.
They override this function to compute the area.
Others return 0.0 */
    area!: number;
    /** Returns the length of this Geometry.
Linear geometries return their length.
Areal geometries return their perimeter.
They override this function to compute the length.
Others return 0.0 */
    length!: number;
    /** Computes the centroid of this Geometry.
The centroid
is equal to the centroid of the set of component Geometries of highest
dimension (since the lower-dimension geometries contribute zero
"weight" to the centroid).

The centroid of an empty geometry is POINT EMPTY. */
    centroid?: Point | null;
    /** Computes an interior point of this Geometry. */
    interiorPoint?: Point | null;
    /** InteriorPoint */
    pointOnSurface?: Point | null;
    /** Gets a geometry representing the envelope (bounding box) of this Geometry. */
    envelope?: Geometry | null;
    /** Gets an Envelope containing
the minimum and maximum x and y values in this Geometry.
If the geometry is empty, an empty Envelope
is returned. */
    envelopeInternal?: Envelope | null;
    /**   */
    isRectangle!: boolean;

    constructor(data?: IGeometry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.factory = data["factory"] ? GeometryFactory.fromJS(data["factory"]) : <any>null;
            this.userData = data["userData"] !== undefined ? data["userData"] : <any>null;
            this.srid = data["srid"] !== undefined ? data["srid"] : <any>null;
            this.precisionModel = data["precisionModel"] ? PrecisionModel.fromJS(data["precisionModel"]) : <any>null;
            this.numGeometries = data["numGeometries"] !== undefined ? data["numGeometries"] : <any>null;
            this.isSimple = data["isSimple"] !== undefined ? data["isSimple"] : <any>null;
            this.isValid = data["isValid"] !== undefined ? data["isValid"] : <any>null;
            this.area = data["area"] !== undefined ? data["area"] : <any>null;
            this.length = data["length"] !== undefined ? data["length"] : <any>null;
            this.centroid = data["centroid"] ? Point.fromJS(data["centroid"]) : <any>null;
            this.interiorPoint = data["interiorPoint"] ? Point.fromJS(data["interiorPoint"]) : <any>null;
            this.pointOnSurface = data["pointOnSurface"] ? Point.fromJS(data["pointOnSurface"]) : <any>null;
            this.envelope = data["envelope"] ? Geometry.fromJS(data["envelope"]) : <any>null;
            this.envelopeInternal = data["envelopeInternal"] ? Envelope.fromJS(data["envelopeInternal"]) : <any>null;
            this.isRectangle = data["isRectangle"] !== undefined ? data["isRectangle"] : <any>null;
        }
    }

    static fromJS(data: any): Geometry {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Geometry' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>null;
        data["userData"] = this.userData !== undefined ? this.userData : <any>null;
        data["srid"] = this.srid !== undefined ? this.srid : <any>null;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>null;
        data["numGeometries"] = this.numGeometries !== undefined ? this.numGeometries : <any>null;
        data["isSimple"] = this.isSimple !== undefined ? this.isSimple : <any>null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        data["area"] = this.area !== undefined ? this.area : <any>null;
        data["length"] = this.length !== undefined ? this.length : <any>null;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>null;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>null;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>null;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>null;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>null;
        data["isRectangle"] = this.isRectangle !== undefined ? this.isRectangle : <any>null;
        return data; 
    }

    clone(): Geometry {
        throw new Error("The abstract class 'Geometry' cannot be instantiated.");
    }
}

/** A representation of a planar, linear vector geometry. */
export interface IGeometry {
    /** Gets the factory which contains the context in which this point was created. */
    factory?: GeometryFactory | null;
    /** Gets/Sets the user data object for this point, if any. */
    userData?: any | null;
    /** Sets the ID of the Spatial Reference System used by the Geometry. */
    srid: number;
    /** Returns the PrecisionModel used by the Geometry. */
    precisionModel?: PrecisionModel | null;
    /** Returns the number of Geometryes in a GeometryCollection,
or 1, if the geometry is not a collection. */
    numGeometries: number;
    /** Tests whether this Geometry is simple.

The SFS definition of simplicity
follows the general rule that a Geometry is simple if it has no points of
self-tangency, self-intersection or other anomalous points.

Simplicity is defined for each Geometry subclass as follows:

Valid polygonal geometries are simple, since their rings
must not self-intersect. IsSimple
tests for this condition and reports false if it is not met.
(This is a looser test than checking for validity).
Linear rings have the same semantics.
Linear geometries are simple iff they do not self-intersect at points
other than boundary points.
Zero-dimensional geometries (points) are simple iff they have no
repeated points.
Empty Geometrys are always simple. */
    isSimple: boolean;
    /** Tests whether this Geometry is topologically
valid, according to the OGC SFS specification.
For validity rules see the documentation for the specific geometry subclass. */
    isValid: boolean;
    /** Returns the area of this Geometry.
Areal Geometries have a non-zero area.
They override this function to compute the area.
Others return 0.0 */
    area: number;
    /** Returns the length of this Geometry.
Linear geometries return their length.
Areal geometries return their perimeter.
They override this function to compute the length.
Others return 0.0 */
    length: number;
    /** Computes the centroid of this Geometry.
The centroid
is equal to the centroid of the set of component Geometries of highest
dimension (since the lower-dimension geometries contribute zero
"weight" to the centroid).

The centroid of an empty geometry is POINT EMPTY. */
    centroid?: Point | null;
    /** Computes an interior point of this Geometry. */
    interiorPoint?: Point | null;
    /** InteriorPoint */
    pointOnSurface?: Point | null;
    /** Gets a geometry representing the envelope (bounding box) of this Geometry. */
    envelope?: Geometry | null;
    /** Gets an Envelope containing
the minimum and maximum x and y values in this Geometry.
If the geometry is empty, an empty Envelope
is returned. */
    envelopeInternal?: Envelope | null;
    /**   */
    isRectangle: boolean;
}

/** Represents a single point. A Point is topologically valid if and only if: The coordinate which defines it if any) is a valid coordinate (i.e. does not have an NaN X- or Y-ordinate */
export class Point extends Geometry implements IPoint {
    /**   */
    coordinateSequence?: CoordinateSequence | null;
    /**   */
    coordinates?: Coordinate[] | null;
    /**   */
    numPoints!: number;
    /**   */
    isEmpty!: boolean;
    /**   */
    dimension!: Dimension;
    /**   */
    boundaryDimension!: Dimension;
    /**   */
    x!: number;
    /**   */
    y!: number;
    /**   */
    coordinate?: Coordinate | null;
    /** Returns the name of this object's interface. */
    geometryType?: string | null;
    /** Gets the OGC geometry type */
    ogcGeometryType!: OgcGeometryType;
    /** Gets the boundary of this geometry.
Zero-dimensional geometries have no boundary by definition,
so an empty GeometryCollection is returned.
  */
    boundary?: Geometry | null;
    /**   */
    z!: number;
    m!: number;

    constructor(data?: IPoint) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.coordinateSequence = data["coordinateSequence"] ? CoordinateSequence.fromJS(data["coordinateSequence"]) : <any>null;
            if (Array.isArray(data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of data["coordinates"])
                    this.coordinates!.push(Coordinate.fromJS(item));
            }
            this.numPoints = data["numPoints"] !== undefined ? data["numPoints"] : <any>null;
            this.isEmpty = data["isEmpty"] !== undefined ? data["isEmpty"] : <any>null;
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : <any>null;
            this.boundaryDimension = data["boundaryDimension"] !== undefined ? data["boundaryDimension"] : <any>null;
            this.x = data["x"] !== undefined ? data["x"] : <any>null;
            this.y = data["y"] !== undefined ? data["y"] : <any>null;
            this.coordinate = data["coordinate"] ? Coordinate.fromJS(data["coordinate"]) : <any>null;
            this.geometryType = data["geometryType"] !== undefined ? data["geometryType"] : <any>null;
            this.ogcGeometryType = data["ogcGeometryType"] !== undefined ? data["ogcGeometryType"] : <any>null;
            this.boundary = data["boundary"] ? Geometry.fromJS(data["boundary"]) : <any>null;
            this.z = data["z"] !== undefined ? data["z"] : <any>null;
            this.m = data["m"] !== undefined ? data["m"] : <any>null;
        }
    }

    static fromJS(data: any): Point {
        data = typeof data === 'object' ? data : {};
        let result = new Point();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coordinateSequence"] = this.coordinateSequence ? this.coordinateSequence.toJSON() : <any>null;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints !== undefined ? this.numPoints : <any>null;
        data["isEmpty"] = this.isEmpty !== undefined ? this.isEmpty : <any>null;
        data["dimension"] = this.dimension !== undefined ? this.dimension : <any>null;
        data["boundaryDimension"] = this.boundaryDimension !== undefined ? this.boundaryDimension : <any>null;
        data["x"] = this.x !== undefined ? this.x : <any>null;
        data["y"] = this.y !== undefined ? this.y : <any>null;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>null;
        data["geometryType"] = this.geometryType !== undefined ? this.geometryType : <any>null;
        data["ogcGeometryType"] = this.ogcGeometryType !== undefined ? this.ogcGeometryType : <any>null;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>null;
        data["z"] = this.z !== undefined ? this.z : <any>null;
        data["m"] = this.m !== undefined ? this.m : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): Point {
        const json = this.toJSON();
        let result = new Point();
        result.init(json);
        return result;
    }
}

/** Represents a single point. A Point is topologically valid if and only if: The coordinate which defines it if any) is a valid coordinate (i.e. does not have an NaN X- or Y-ordinate */
export interface IPoint extends IGeometry {
    /**   */
    coordinateSequence?: CoordinateSequence | null;
    /**   */
    coordinates?: Coordinate[] | null;
    /**   */
    numPoints: number;
    /**   */
    isEmpty: boolean;
    /**   */
    dimension: Dimension;
    /**   */
    boundaryDimension: Dimension;
    /**   */
    x: number;
    /**   */
    y: number;
    /**   */
    coordinate?: Coordinate | null;
    /** Returns the name of this object's interface. */
    geometryType?: string | null;
    /** Gets the OGC geometry type */
    ogcGeometryType: OgcGeometryType;
    /** Gets the boundary of this geometry.
Zero-dimensional geometries have no boundary by definition,
so an empty GeometryCollection is returned.
  */
    boundary?: Geometry | null;
    /**   */
    z: number;
    m: number;
}

/** The internal representation of a list of coordinates inside a Geometry. This allows Geometries to store their points using something other than the NTS  class. For example, a storage-efficient implementation might store coordinate sequences as an array of x's and an array of y's. Or a custom coordinate class might support extra attributes like M-values. Implementing a custom coordinate storage structure requires implementing the  and abstract classes. To use the custom CoordinateSequence, create a new  parameterized by the CoordinateSequenceFactory The  can then be used to create new s. The new Geometries will use the custom CoordinateSequence implementation. */
export abstract class CoordinateSequence implements ICoordinateSequence {
    /** Returns the dimension (number of ordinates in each coordinate) for this sequence.

This total includes any measures, indicated by non-zero . */
    dimension!: number;
    /** Gets the number of measures included in Dimension for each coordinate for this
sequence. */
    measures!: number;
    /** Gets the number of non-measure dimensions included in Dimension for each
coordinate for this sequence.

Equivalent to Dimension - Measures. */
    spatial!: number;
    /** Gets the kind of ordinates this sequence supplies. */
    ordinates!: Ordinates;
    /** Gets a value indicating if Int32) is supported. */
    hasZ!: boolean;
    /** Gets a value indicating if Int32) is supported. */
    hasM!: boolean;
    /** Gets the index of the Z ordinate (for use with Int32) or
Double)), or -1 if HasZ is
false. */
    zOrdinateIndex!: number;
    /** Gets the index of the M ordinate (for use with Int32) or
Double)), or -1 if HasM is
false. */
    mOrdinateIndex!: number;
    /** Gets a value indicating the number of coordinates in this sequence. */
    count!: number;

    constructor(data?: ICoordinateSequence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : <any>null;
            this.measures = data["measures"] !== undefined ? data["measures"] : <any>null;
            this.spatial = data["spatial"] !== undefined ? data["spatial"] : <any>null;
            this.ordinates = data["ordinates"] !== undefined ? data["ordinates"] : <any>null;
            this.hasZ = data["hasZ"] !== undefined ? data["hasZ"] : <any>null;
            this.hasM = data["hasM"] !== undefined ? data["hasM"] : <any>null;
            this.zOrdinateIndex = data["zOrdinateIndex"] !== undefined ? data["zOrdinateIndex"] : <any>null;
            this.mOrdinateIndex = data["mOrdinateIndex"] !== undefined ? data["mOrdinateIndex"] : <any>null;
            this.count = data["count"] !== undefined ? data["count"] : <any>null;
        }
    }

    static fromJS(data: any): CoordinateSequence {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CoordinateSequence' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : <any>null;
        data["measures"] = this.measures !== undefined ? this.measures : <any>null;
        data["spatial"] = this.spatial !== undefined ? this.spatial : <any>null;
        data["ordinates"] = this.ordinates !== undefined ? this.ordinates : <any>null;
        data["hasZ"] = this.hasZ !== undefined ? this.hasZ : <any>null;
        data["hasM"] = this.hasM !== undefined ? this.hasM : <any>null;
        data["zOrdinateIndex"] = this.zOrdinateIndex !== undefined ? this.zOrdinateIndex : <any>null;
        data["mOrdinateIndex"] = this.mOrdinateIndex !== undefined ? this.mOrdinateIndex : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data; 
    }

    clone(): CoordinateSequence {
        throw new Error("The abstract class 'CoordinateSequence' cannot be instantiated.");
    }
}

/** The internal representation of a list of coordinates inside a Geometry. This allows Geometries to store their points using something other than the NTS  class. For example, a storage-efficient implementation might store coordinate sequences as an array of x's and an array of y's. Or a custom coordinate class might support extra attributes like M-values. Implementing a custom coordinate storage structure requires implementing the  and abstract classes. To use the custom CoordinateSequence, create a new  parameterized by the CoordinateSequenceFactory The  can then be used to create new s. The new Geometries will use the custom CoordinateSequence implementation. */
export interface ICoordinateSequence {
    /** Returns the dimension (number of ordinates in each coordinate) for this sequence.

This total includes any measures, indicated by non-zero . */
    dimension: number;
    /** Gets the number of measures included in Dimension for each coordinate for this
sequence. */
    measures: number;
    /** Gets the number of non-measure dimensions included in Dimension for each
coordinate for this sequence.

Equivalent to Dimension - Measures. */
    spatial: number;
    /** Gets the kind of ordinates this sequence supplies. */
    ordinates: Ordinates;
    /** Gets a value indicating if Int32) is supported. */
    hasZ: boolean;
    /** Gets a value indicating if Int32) is supported. */
    hasM: boolean;
    /** Gets the index of the Z ordinate (for use with Int32) or
Double)), or -1 if HasZ is
false. */
    zOrdinateIndex: number;
    /** Gets the index of the M ordinate (for use with Int32) or
Double)), or -1 if HasM is
false. */
    mOrdinateIndex: number;
    /** Gets a value indicating the number of coordinates in this sequence. */
    count: number;
}

/** Flags for Ordinate values */
export enum Ordinates {
    None = 0,
    X = 1,
    Spatial1 = 1,
    Y = 2,
    Spatial2 = 2,
    XY = 3,
    Spatial3 = 4,
    Z = 4,
    XYZ = 7,
    Spatial4 = 8,
    Spatial5 = 16,
    Spatial6 = 32,
    Spatial7 = 64,
    Spatial8 = 128,
    Spatial9 = 256,
    Spatial10 = 512,
    Spatial11 = 1024,
    Spatial12 = 2048,
    Spatial13 = 4096,
    Spatial14 = 8192,
    Spatial15 = 16384,
    Spatial16 = 32768,
    AllSpatialOrdinates = 65535,
    Measure1 = 65536,
    M = 65536,
    XYM = 65539,
    XYZM = 65543,
    Measure2 = 131072,
    Measure3 = 262144,
    Measure4 = 524288,
    Measure5 = 1048576,
    Measure6 = 2097152,
    Measure7 = 4194304,
    Measure8 = 8388608,
    Measure9 = 16777216,
    Measure10 = 33554432,
    Measure11 = 67108864,
    Measure12 = 134217728,
    Measure13 = 268435456,
    Measure14 = 536870912,
    Measure15 = 1073741824,
    Measure16 = -2147483648,
    AllMeasureOrdinates = -65536,
    AllOrdinates = -1,
}

/** A lightweight class used to store coordinates on the 2-dimensional Cartesian plane. The base data object is suitable for use with coordinate sequences with dimension = 2 and measures = 0. */
export class Coordinate implements ICoordinate {
    /** Gets or sets the X-ordinate value. */
    x!: number;
    /** Gets or sets the Y-ordinate value. */
    y!: number;
    /** Gets or sets the Z-ordinate value, if supported.
If no Z value is present, returns NullOrdinate. */
    z!: number;
    /** Gets or sets the value of the measure, if supported.
If no measure value is present, returns NullOrdinate. */
    m!: number;
    /** Gets/Sets Coordinates (x,y,z) values. */
    coordinateValue?: Coordinate | null;

    constructor(data?: ICoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.x = data["x"] !== undefined ? data["x"] : <any>null;
            this.y = data["y"] !== undefined ? data["y"] : <any>null;
            this.z = data["z"] !== undefined ? data["z"] : <any>null;
            this.m = data["m"] !== undefined ? data["m"] : <any>null;
            this.coordinateValue = data["coordinateValue"] ? Coordinate.fromJS(data["coordinateValue"]) : <any>null;
        }
    }

    static fromJS(data: any): Coordinate {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x !== undefined ? this.x : <any>null;
        data["y"] = this.y !== undefined ? this.y : <any>null;
        data["z"] = this.z !== undefined ? this.z : <any>null;
        data["m"] = this.m !== undefined ? this.m : <any>null;
        data["coordinateValue"] = this.coordinateValue ? this.coordinateValue.toJSON() : <any>null;
        return data; 
    }

    clone(): Coordinate {
        const json = this.toJSON();
        let result = new Coordinate();
        result.init(json);
        return result;
    }
}

/** A lightweight class used to store coordinates on the 2-dimensional Cartesian plane. The base data object is suitable for use with coordinate sequences with dimension = 2 and measures = 0. */
export interface ICoordinate {
    /** Gets or sets the X-ordinate value. */
    x: number;
    /** Gets or sets the Y-ordinate value. */
    y: number;
    /** Gets or sets the Z-ordinate value, if supported.
If no Z value is present, returns NullOrdinate. */
    z: number;
    /** Gets or sets the value of the measure, if supported.
If no measure value is present, returns NullOrdinate. */
    m: number;
    /** Gets/Sets Coordinates (x,y,z) values. */
    coordinateValue?: Coordinate | null;
}

/** Provides constants representing the dimensions of a point, a curve and a surface. */
export enum Dimension {
    Point = 0,
    Curve = 1,
    Surface = 2,
    Dontcare = -3,
    True = -2,
    False = -1,
}

/** Enumeration of OGC Geometry Types */
export enum OgcGeometryType {
    Point = 1,
    LineString = 2,
    Polygon = 3,
    MultiPoint = 4,
    MultiLineString = 5,
    MultiPolygon = 6,
    GeometryCollection = 7,
    CircularString = 8,
    CompoundCurve = 9,
    CurvePolygon = 10,
    MultiCurve = 11,
    MultiSurface = 12,
    Curve = 13,
    Surface = 14,
    PolyhedralSurface = 15,
    TIN = 16,
}

/** Supplies a set of utility methods for building Geometry objects from lists of Coordinates. */
export class GeometryFactory implements IGeometryFactory {
    /** Returns the PrecisionModel that Geometries created by this factory
will be associated with. */
    precisionModel?: PrecisionModel | null;
    /**   */
    coordinateSequenceFactory?: CoordinateSequenceFactory | null;
    /** The SRID value defined for this factory. */
    srid!: number;

    constructor(data?: IGeometryFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.precisionModel = data["precisionModel"] ? PrecisionModel.fromJS(data["precisionModel"]) : <any>null;
            this.coordinateSequenceFactory = data["coordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(data["coordinateSequenceFactory"]) : <any>null;
            this.srid = data["srid"] !== undefined ? data["srid"] : <any>null;
        }
    }

    static fromJS(data: any): GeometryFactory {
        data = typeof data === 'object' ? data : {};
        let result = new GeometryFactory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>null;
        data["coordinateSequenceFactory"] = this.coordinateSequenceFactory ? this.coordinateSequenceFactory.toJSON() : <any>null;
        data["srid"] = this.srid !== undefined ? this.srid : <any>null;
        return data; 
    }

    clone(): GeometryFactory {
        const json = this.toJSON();
        let result = new GeometryFactory();
        result.init(json);
        return result;
    }
}

/** Supplies a set of utility methods for building Geometry objects from lists of Coordinates. */
export interface IGeometryFactory {
    /** Returns the PrecisionModel that Geometries created by this factory
will be associated with. */
    precisionModel?: PrecisionModel | null;
    /**   */
    coordinateSequenceFactory?: CoordinateSequenceFactory | null;
    /** The SRID value defined for this factory. */
    srid: number;
}

/** Specifies the precision model of the Coordinates in a Geometry. In other words, specifies the grid of allowable points for all Geometrys. */
export class PrecisionModel implements IPrecisionModel {
    /** Tests whether the precision model supports floating point. */
    isFloating!: boolean;
    /** Returns the maximum number of significant digits provided by this
precision model.
Intended for use by routines which need to print out precise values. */
    maximumSignificantDigits!: number;
    /** Returns the scale factor used to specify a fixed precision model. */
    scale!: number;
    /** Gets the type of this PrecisionModel. */
    precisionModelType!: PrecisionModels;

    constructor(data?: IPrecisionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isFloating = data["isFloating"] !== undefined ? data["isFloating"] : <any>null;
            this.maximumSignificantDigits = data["maximumSignificantDigits"] !== undefined ? data["maximumSignificantDigits"] : <any>null;
            this.scale = data["scale"] !== undefined ? data["scale"] : <any>null;
            this.precisionModelType = data["precisionModelType"] !== undefined ? data["precisionModelType"] : <any>null;
        }
    }

    static fromJS(data: any): PrecisionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrecisionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFloating"] = this.isFloating !== undefined ? this.isFloating : <any>null;
        data["maximumSignificantDigits"] = this.maximumSignificantDigits !== undefined ? this.maximumSignificantDigits : <any>null;
        data["scale"] = this.scale !== undefined ? this.scale : <any>null;
        data["precisionModelType"] = this.precisionModelType !== undefined ? this.precisionModelType : <any>null;
        return data; 
    }

    clone(): PrecisionModel {
        const json = this.toJSON();
        let result = new PrecisionModel();
        result.init(json);
        return result;
    }
}

/** Specifies the precision model of the Coordinates in a Geometry. In other words, specifies the grid of allowable points for all Geometrys. */
export interface IPrecisionModel {
    /** Tests whether the precision model supports floating point. */
    isFloating: boolean;
    /** Returns the maximum number of significant digits provided by this
precision model.
Intended for use by routines which need to print out precise values. */
    maximumSignificantDigits: number;
    /** Returns the scale factor used to specify a fixed precision model. */
    scale: number;
    /** Gets the type of this PrecisionModel. */
    precisionModelType: PrecisionModels;
}

export enum PrecisionModels {
    Floating = 0,
    FloatingSingle = 1,
    Fixed = 2,
}

/** An object that knows how to build a particular implementation of CoordinateSequence from an array of Coordinates. */
export abstract class CoordinateSequenceFactory implements ICoordinateSequenceFactory {
    /** Gets the Ordinate flags that sequences created by this factory can maximal cope with. */
    ordinates!: Ordinates;

    constructor(data?: ICoordinateSequenceFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ordinates = data["ordinates"] !== undefined ? data["ordinates"] : <any>null;
        }
    }

    static fromJS(data: any): CoordinateSequenceFactory {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CoordinateSequenceFactory' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinates"] = this.ordinates !== undefined ? this.ordinates : <any>null;
        return data; 
    }

    clone(): CoordinateSequenceFactory {
        throw new Error("The abstract class 'CoordinateSequenceFactory' cannot be instantiated.");
    }
}

/** An object that knows how to build a particular implementation of CoordinateSequence from an array of Coordinates. */
export interface ICoordinateSequenceFactory {
    /** Gets the Ordinate flags that sequences created by this factory can maximal cope with. */
    ordinates: Ordinates;
}

/** Defines a rectangular region of the 2D coordinate plane. */
export class Envelope implements IEnvelope {
    /** Returns true if this Envelope is a "null" envelope. */
    isNull!: boolean;
    /** Returns the difference between the maximum and minimum x values. */
    width!: number;
    /** Returns the difference between the maximum and minimum y values. */
    height!: number;
    /** Returns the Envelopes minimum x-value. min x &gt; max x
indicates that this is a null Envelope. */
    minX!: number;
    /** Returns the Envelopes maximum x-value. min x &gt; max x
indicates that this is a null Envelope. */
    maxX!: number;
    /** Returns the Envelopes minimum y-value. min y &gt; max y
indicates that this is a null Envelope. */
    minY!: number;
    /** Returns the Envelopes maximum y-value. min y &gt; max y
indicates that this is a null Envelope. */
    maxY!: number;
    /** Gets the area of this envelope. */
    area!: number;
    /** Gets the minimum extent of this envelope across both dimensions. */
    minExtent!: number;
    /** Gets the maximum extent of this envelope across both dimensions. */
    maxExtent!: number;
    /** Computes the coordinate of the centre of this envelope (as long as it is non-null). */
    centre?: Coordinate | null;

    constructor(data?: IEnvelope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isNull = data["isNull"] !== undefined ? data["isNull"] : <any>null;
            this.width = data["width"] !== undefined ? data["width"] : <any>null;
            this.height = data["height"] !== undefined ? data["height"] : <any>null;
            this.minX = data["minX"] !== undefined ? data["minX"] : <any>null;
            this.maxX = data["maxX"] !== undefined ? data["maxX"] : <any>null;
            this.minY = data["minY"] !== undefined ? data["minY"] : <any>null;
            this.maxY = data["maxY"] !== undefined ? data["maxY"] : <any>null;
            this.area = data["area"] !== undefined ? data["area"] : <any>null;
            this.minExtent = data["minExtent"] !== undefined ? data["minExtent"] : <any>null;
            this.maxExtent = data["maxExtent"] !== undefined ? data["maxExtent"] : <any>null;
            this.centre = data["centre"] ? Coordinate.fromJS(data["centre"]) : <any>null;
        }
    }

    static fromJS(data: any): Envelope {
        data = typeof data === 'object' ? data : {};
        let result = new Envelope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNull"] = this.isNull !== undefined ? this.isNull : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["minX"] = this.minX !== undefined ? this.minX : <any>null;
        data["maxX"] = this.maxX !== undefined ? this.maxX : <any>null;
        data["minY"] = this.minY !== undefined ? this.minY : <any>null;
        data["maxY"] = this.maxY !== undefined ? this.maxY : <any>null;
        data["area"] = this.area !== undefined ? this.area : <any>null;
        data["minExtent"] = this.minExtent !== undefined ? this.minExtent : <any>null;
        data["maxExtent"] = this.maxExtent !== undefined ? this.maxExtent : <any>null;
        data["centre"] = this.centre ? this.centre.toJSON() : <any>null;
        return data; 
    }

    clone(): Envelope {
        const json = this.toJSON();
        let result = new Envelope();
        result.init(json);
        return result;
    }
}

/** Defines a rectangular region of the 2D coordinate plane. */
export interface IEnvelope {
    /** Returns true if this Envelope is a "null" envelope. */
    isNull: boolean;
    /** Returns the difference between the maximum and minimum x values. */
    width: number;
    /** Returns the difference between the maximum and minimum y values. */
    height: number;
    /** Returns the Envelopes minimum x-value. min x &gt; max x
indicates that this is a null Envelope. */
    minX: number;
    /** Returns the Envelopes maximum x-value. min x &gt; max x
indicates that this is a null Envelope. */
    maxX: number;
    /** Returns the Envelopes minimum y-value. min y &gt; max y
indicates that this is a null Envelope. */
    minY: number;
    /** Returns the Envelopes maximum y-value. min y &gt; max y
indicates that this is a null Envelope. */
    maxY: number;
    /** Gets the area of this envelope. */
    area: number;
    /** Gets the minimum extent of this envelope across both dimensions. */
    minExtent: number;
    /** Gets the maximum extent of this envelope across both dimensions. */
    maxExtent: number;
    /** Computes the coordinate of the centre of this envelope (as long as it is non-null). */
    centre?: Coordinate | null;
}

export class AdvertisementCategory extends BaseModel implements IAdvertisementCategory {
    advertisementCategoryId!: number;
    name!: string;
    code?: string | null;
    orderIndex!: number;
    casualDating!: boolean;

    constructor(data?: IAdvertisementCategory) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.advertisementCategoryId = data["advertisementCategoryId"] !== undefined ? data["advertisementCategoryId"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.code = data["code"] !== undefined ? data["code"] : <any>null;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : <any>null;
            this.casualDating = data["casualDating"] !== undefined ? data["casualDating"] : <any>null;
        }
    }

    static fromJS(data: any): AdvertisementCategory {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementCategoryId"] = this.advertisementCategoryId !== undefined ? this.advertisementCategoryId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["casualDating"] = this.casualDating !== undefined ? this.casualDating : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdvertisementCategory {
        const json = this.toJSON();
        let result = new AdvertisementCategory();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementCategory extends IBaseModel {
    advertisementCategoryId: number;
    name: string;
    code?: string | null;
    orderIndex: number;
    casualDating: boolean;
}

export class AdvertisementImage extends BaseModel implements IAdvertisementImage {
    advertisementImageId!: number;
    advertisementId!: number;
    advertisement?: Advertisement | null;
    name!: string;
    fileName!: string;
    orgFileName?: string | null;
    orderIndex!: number;
    isMain!: boolean;

    constructor(data?: IAdvertisementImage) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.advertisementImageId = data["advertisementImageId"] !== undefined ? data["advertisementImageId"] : <any>null;
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : <any>null;
            this.advertisement = data["advertisement"] ? Advertisement.fromJS(data["advertisement"]) : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : <any>null;
            this.orgFileName = data["orgFileName"] !== undefined ? data["orgFileName"] : <any>null;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : <any>null;
            this.isMain = data["isMain"] !== undefined ? data["isMain"] : <any>null;
        }
    }

    static fromJS(data: any): AdvertisementImage {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementImageId"] = this.advertisementImageId !== undefined ? this.advertisementImageId : <any>null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["advertisement"] = this.advertisement ? this.advertisement.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["orgFileName"] = this.orgFileName !== undefined ? this.orgFileName : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["isMain"] = this.isMain !== undefined ? this.isMain : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AdvertisementImage {
        const json = this.toJSON();
        let result = new AdvertisementImage();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementImage extends IBaseModel {
    advertisementImageId: number;
    advertisementId: number;
    advertisement?: Advertisement | null;
    name: string;
    fileName: string;
    orgFileName?: string | null;
    orderIndex: number;
    isMain: boolean;
}

export class Conversation implements IConversation {
    conversationId!: number;
    senderEmail?: string | null;
    senderNick?: string | null;
    receiverNick?: string | null;
    receiverEmail?: string | null;
    conversationKey?: string | null;
    creationDate!: moment.Moment;
    ownerUserId!: number;
    ownerUser?: User | null;
    receiverUserId!: number;
    receiverUser?: User | null;
    advertisementId!: number;
    advertisement?: Advertisement | null;
    additionalData?: string | null;
    isDeletedOwner!: boolean;
    isDeletedReceiver!: boolean;
    senderNewMessages!: boolean;
    receiverNewMessages!: boolean;
    isForDemoAd!: boolean;
    additionalInformation?: ConversationAdditionalInformations | null;
    messages?: ConversationMessage[] | null;
    lastMessageDate!: moment.Moment;

    constructor(data?: IConversation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.conversationId = data["conversationId"] !== undefined ? data["conversationId"] : <any>null;
            this.senderEmail = data["senderEmail"] !== undefined ? data["senderEmail"] : <any>null;
            this.senderNick = data["senderNick"] !== undefined ? data["senderNick"] : <any>null;
            this.receiverNick = data["receiverNick"] !== undefined ? data["receiverNick"] : <any>null;
            this.receiverEmail = data["receiverEmail"] !== undefined ? data["receiverEmail"] : <any>null;
            this.conversationKey = data["conversationKey"] !== undefined ? data["conversationKey"] : <any>null;
            this.creationDate = data["creationDate"] ? moment(data["creationDate"].toString()) : <any>null;
            this.ownerUserId = data["ownerUserId"] !== undefined ? data["ownerUserId"] : <any>null;
            this.ownerUser = data["ownerUser"] ? User.fromJS(data["ownerUser"]) : <any>null;
            this.receiverUserId = data["receiverUserId"] !== undefined ? data["receiverUserId"] : <any>null;
            this.receiverUser = data["receiverUser"] ? User.fromJS(data["receiverUser"]) : <any>null;
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : <any>null;
            this.advertisement = data["advertisement"] ? Advertisement.fromJS(data["advertisement"]) : <any>null;
            this.additionalData = data["additionalData"] !== undefined ? data["additionalData"] : <any>null;
            this.isDeletedOwner = data["isDeletedOwner"] !== undefined ? data["isDeletedOwner"] : <any>null;
            this.isDeletedReceiver = data["isDeletedReceiver"] !== undefined ? data["isDeletedReceiver"] : <any>null;
            this.senderNewMessages = data["senderNewMessages"] !== undefined ? data["senderNewMessages"] : <any>null;
            this.receiverNewMessages = data["receiverNewMessages"] !== undefined ? data["receiverNewMessages"] : <any>null;
            this.isForDemoAd = data["isForDemoAd"] !== undefined ? data["isForDemoAd"] : <any>null;
            this.additionalInformation = data["additionalInformation"] ? ConversationAdditionalInformations.fromJS(data["additionalInformation"]) : <any>null;
            if (Array.isArray(data["messages"])) {
                this.messages = [] as any;
                for (let item of data["messages"])
                    this.messages!.push(ConversationMessage.fromJS(item));
            }
            this.lastMessageDate = data["lastMessageDate"] ? moment(data["lastMessageDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): Conversation {
        data = typeof data === 'object' ? data : {};
        let result = new Conversation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId !== undefined ? this.conversationId : <any>null;
        data["senderEmail"] = this.senderEmail !== undefined ? this.senderEmail : <any>null;
        data["senderNick"] = this.senderNick !== undefined ? this.senderNick : <any>null;
        data["receiverNick"] = this.receiverNick !== undefined ? this.receiverNick : <any>null;
        data["receiverEmail"] = this.receiverEmail !== undefined ? this.receiverEmail : <any>null;
        data["conversationKey"] = this.conversationKey !== undefined ? this.conversationKey : <any>null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>null;
        data["ownerUserId"] = this.ownerUserId !== undefined ? this.ownerUserId : <any>null;
        data["ownerUser"] = this.ownerUser ? this.ownerUser.toJSON() : <any>null;
        data["receiverUserId"] = this.receiverUserId !== undefined ? this.receiverUserId : <any>null;
        data["receiverUser"] = this.receiverUser ? this.receiverUser.toJSON() : <any>null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["advertisement"] = this.advertisement ? this.advertisement.toJSON() : <any>null;
        data["additionalData"] = this.additionalData !== undefined ? this.additionalData : <any>null;
        data["isDeletedOwner"] = this.isDeletedOwner !== undefined ? this.isDeletedOwner : <any>null;
        data["isDeletedReceiver"] = this.isDeletedReceiver !== undefined ? this.isDeletedReceiver : <any>null;
        data["senderNewMessages"] = this.senderNewMessages !== undefined ? this.senderNewMessages : <any>null;
        data["receiverNewMessages"] = this.receiverNewMessages !== undefined ? this.receiverNewMessages : <any>null;
        data["isForDemoAd"] = this.isForDemoAd !== undefined ? this.isForDemoAd : <any>null;
        data["additionalInformation"] = this.additionalInformation ? this.additionalInformation.toJSON() : <any>null;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["lastMessageDate"] = this.lastMessageDate ? this.lastMessageDate.toISOString() : <any>null;
        return data; 
    }

    clone(): Conversation {
        const json = this.toJSON();
        let result = new Conversation();
        result.init(json);
        return result;
    }
}

export interface IConversation {
    conversationId: number;
    senderEmail?: string | null;
    senderNick?: string | null;
    receiverNick?: string | null;
    receiverEmail?: string | null;
    conversationKey?: string | null;
    creationDate: moment.Moment;
    ownerUserId: number;
    ownerUser?: User | null;
    receiverUserId: number;
    receiverUser?: User | null;
    advertisementId: number;
    advertisement?: Advertisement | null;
    additionalData?: string | null;
    isDeletedOwner: boolean;
    isDeletedReceiver: boolean;
    senderNewMessages: boolean;
    receiverNewMessages: boolean;
    isForDemoAd: boolean;
    additionalInformation?: ConversationAdditionalInformations | null;
    messages?: ConversationMessage[] | null;
    lastMessageDate: moment.Moment;
}

export class User implements IUser {
    userId!: number;
    createdAt!: moment.Moment;
    updatedAt!: moment.Moment;
    nick?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    email!: string;
    phone?: string | null;
    password!: string;
    passwordSalt!: string;
    isDemo!: boolean;
    isInternal!: boolean;
    isAdmin!: boolean;
    isEmailVerified!: boolean;
    isPremium!: boolean;
    isPhoneVerified!: boolean;
    isDisabled!: boolean;
    zipCode?: string | null;
    city?: string | null;
    state?: string | null;
    location?: Point | null;
    premiumAdTokens!: number;
    writeAdTokens!: number;
    thirdPartyAdTokens!: number;
    subscribtionExpiration?: moment.Moment | null;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.createdAt = data["createdAt"] ? moment(data["createdAt"].toString()) : <any>null;
            this.updatedAt = data["updatedAt"] ? moment(data["updatedAt"].toString()) : <any>null;
            this.nick = data["nick"] !== undefined ? data["nick"] : <any>null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : <any>null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : <any>null;
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
            this.phone = data["phone"] !== undefined ? data["phone"] : <any>null;
            this.password = data["password"] !== undefined ? data["password"] : <any>null;
            this.passwordSalt = data["passwordSalt"] !== undefined ? data["passwordSalt"] : <any>null;
            this.isDemo = data["isDemo"] !== undefined ? data["isDemo"] : <any>null;
            this.isInternal = data["isInternal"] !== undefined ? data["isInternal"] : <any>null;
            this.isAdmin = data["isAdmin"] !== undefined ? data["isAdmin"] : <any>null;
            this.isEmailVerified = data["isEmailVerified"] !== undefined ? data["isEmailVerified"] : <any>null;
            this.isPremium = data["isPremium"] !== undefined ? data["isPremium"] : <any>null;
            this.isPhoneVerified = data["isPhoneVerified"] !== undefined ? data["isPhoneVerified"] : <any>null;
            this.isDisabled = data["isDisabled"] !== undefined ? data["isDisabled"] : <any>null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : <any>null;
            this.city = data["city"] !== undefined ? data["city"] : <any>null;
            this.state = data["state"] !== undefined ? data["state"] : <any>null;
            this.location = data["location"] ? Point.fromJS(data["location"]) : <any>null;
            this.premiumAdTokens = data["premiumAdTokens"] !== undefined ? data["premiumAdTokens"] : <any>null;
            this.writeAdTokens = data["writeAdTokens"] !== undefined ? data["writeAdTokens"] : <any>null;
            this.thirdPartyAdTokens = data["thirdPartyAdTokens"] !== undefined ? data["thirdPartyAdTokens"] : <any>null;
            this.subscribtionExpiration = data["subscribtionExpiration"] ? moment(data["subscribtionExpiration"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["nick"] = this.nick !== undefined ? this.nick : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["passwordSalt"] = this.passwordSalt !== undefined ? this.passwordSalt : <any>null;
        data["isDemo"] = this.isDemo !== undefined ? this.isDemo : <any>null;
        data["isInternal"] = this.isInternal !== undefined ? this.isInternal : <any>null;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : <any>null;
        data["isEmailVerified"] = this.isEmailVerified !== undefined ? this.isEmailVerified : <any>null;
        data["isPremium"] = this.isPremium !== undefined ? this.isPremium : <any>null;
        data["isPhoneVerified"] = this.isPhoneVerified !== undefined ? this.isPhoneVerified : <any>null;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["location"] = this.location ? this.location.toJSON() : <any>null;
        data["premiumAdTokens"] = this.premiumAdTokens !== undefined ? this.premiumAdTokens : <any>null;
        data["writeAdTokens"] = this.writeAdTokens !== undefined ? this.writeAdTokens : <any>null;
        data["thirdPartyAdTokens"] = this.thirdPartyAdTokens !== undefined ? this.thirdPartyAdTokens : <any>null;
        data["subscribtionExpiration"] = this.subscribtionExpiration ? this.subscribtionExpiration.toISOString() : <any>null;
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    userId: number;
    createdAt: moment.Moment;
    updatedAt: moment.Moment;
    nick?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    email: string;
    phone?: string | null;
    password: string;
    passwordSalt: string;
    isDemo: boolean;
    isInternal: boolean;
    isAdmin: boolean;
    isEmailVerified: boolean;
    isPremium: boolean;
    isPhoneVerified: boolean;
    isDisabled: boolean;
    zipCode?: string | null;
    city?: string | null;
    state?: string | null;
    location?: Point | null;
    premiumAdTokens: number;
    writeAdTokens: number;
    thirdPartyAdTokens: number;
    subscribtionExpiration?: moment.Moment | null;
}

export class ConversationMessage implements IConversationMessage {
    conversationMessageId!: number;
    conversation?: Conversation | null;
    content?: string | null;
    creationDate!: moment.Moment;
    sender?: User | null;
    senderId!: number;
    title?: string | null;
    images?: ConversationImage[] | null;
    isRead!: boolean;

    constructor(data?: IConversationMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.conversationMessageId = data["conversationMessageId"] !== undefined ? data["conversationMessageId"] : <any>null;
            this.conversation = data["conversation"] ? Conversation.fromJS(data["conversation"]) : <any>null;
            this.content = data["content"] !== undefined ? data["content"] : <any>null;
            this.creationDate = data["creationDate"] ? moment(data["creationDate"].toString()) : <any>null;
            this.sender = data["sender"] ? User.fromJS(data["sender"]) : <any>null;
            this.senderId = data["senderId"] !== undefined ? data["senderId"] : <any>null;
            this.title = data["title"] !== undefined ? data["title"] : <any>null;
            if (Array.isArray(data["images"])) {
                this.images = [] as any;
                for (let item of data["images"])
                    this.images!.push(ConversationImage.fromJS(item));
            }
            this.isRead = data["isRead"] !== undefined ? data["isRead"] : <any>null;
        }
    }

    static fromJS(data: any): ConversationMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationMessageId"] = this.conversationMessageId !== undefined ? this.conversationMessageId : <any>null;
        data["conversation"] = this.conversation ? this.conversation.toJSON() : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>null;
        data["sender"] = this.sender ? this.sender.toJSON() : <any>null;
        data["senderId"] = this.senderId !== undefined ? this.senderId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["isRead"] = this.isRead !== undefined ? this.isRead : <any>null;
        return data; 
    }

    clone(): ConversationMessage {
        const json = this.toJSON();
        let result = new ConversationMessage();
        result.init(json);
        return result;
    }
}

export interface IConversationMessage {
    conversationMessageId: number;
    conversation?: Conversation | null;
    content?: string | null;
    creationDate: moment.Moment;
    sender?: User | null;
    senderId: number;
    title?: string | null;
    images?: ConversationImage[] | null;
    isRead: boolean;
}

export class ConversationImage implements IConversationImage {
    conversationImageId!: number;
    conversationMessage?: ConversationMessage | null;
    name?: string | null;
    fileName?: string | null;

    constructor(data?: IConversationImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.conversationImageId = data["conversationImageId"] !== undefined ? data["conversationImageId"] : <any>null;
            this.conversationMessage = data["conversationMessage"] ? ConversationMessage.fromJS(data["conversationMessage"]) : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): ConversationImage {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationImageId"] = this.conversationImageId !== undefined ? this.conversationImageId : <any>null;
        data["conversationMessage"] = this.conversationMessage ? this.conversationMessage.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data; 
    }

    clone(): ConversationImage {
        const json = this.toJSON();
        let result = new ConversationImage();
        result.init(json);
        return result;
    }
}

export interface IConversationImage {
    conversationImageId: number;
    conversationMessage?: ConversationMessage | null;
    name?: string | null;
    fileName?: string | null;
}

export class AdvertisementSetting implements IAdvertisementSetting {
    advertisementSettingId!: number;
    advertisementId!: number;
    showAs!: ShowAdType;
    advertisement?: Advertisement | null;

    constructor(data?: IAdvertisementSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.advertisementSettingId = data["advertisementSettingId"] !== undefined ? data["advertisementSettingId"] : <any>null;
            this.advertisementId = data["advertisementId"] !== undefined ? data["advertisementId"] : <any>null;
            this.showAs = data["showAs"] !== undefined ? data["showAs"] : <any>null;
            this.advertisement = data["advertisement"] ? Advertisement.fromJS(data["advertisement"]) : <any>null;
        }
    }

    static fromJS(data: any): AdvertisementSetting {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertisementSettingId"] = this.advertisementSettingId !== undefined ? this.advertisementSettingId : <any>null;
        data["advertisementId"] = this.advertisementId !== undefined ? this.advertisementId : <any>null;
        data["showAs"] = this.showAs !== undefined ? this.showAs : <any>null;
        data["advertisement"] = this.advertisement ? this.advertisement.toJSON() : <any>null;
        return data; 
    }

    clone(): AdvertisementSetting {
        const json = this.toJSON();
        let result = new AdvertisementSetting();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementSetting {
    advertisementSettingId: number;
    advertisementId: number;
    showAs: ShowAdType;
    advertisement?: Advertisement | null;
}

export class VerifyPhoneResponseModel extends ResponseBaseModel implements IVerifyPhoneResponseModel {

    constructor(data?: IVerifyPhoneResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): VerifyPhoneResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPhoneResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): VerifyPhoneResponseModel {
        const json = this.toJSON();
        let result = new VerifyPhoneResponseModel();
        result.init(json);
        return result;
    }
}

export interface IVerifyPhoneResponseModel extends IResponseBaseModel {
}

export class VerifyPhoneModel implements IVerifyPhoneModel {
    userId!: number;

    constructor(data?: IVerifyPhoneModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): VerifyPhoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPhoneModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data; 
    }

    clone(): VerifyPhoneModel {
        const json = this.toJSON();
        let result = new VerifyPhoneModel();
        result.init(json);
        return result;
    }
}

export interface IVerifyPhoneModel {
    userId: number;
}

export class ZipRequest implements IZipRequest {
    zip?: string | null;

    constructor(data?: IZipRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.zip = data["zip"] !== undefined ? data["zip"] : <any>null;
        }
    }

    static fromJS(data: any): ZipRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ZipRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        return data; 
    }

    clone(): ZipRequest {
        const json = this.toJSON();
        let result = new ZipRequest();
        result.init(json);
        return result;
    }
}

export interface IZipRequest {
    zip?: string | null;
}

export class WeatherForecast implements IWeatherForecast {
    dateFormatted?: string | null;
    temperatureC!: number;
    summary?: string | null;
    temperatureF!: number;

    constructor(data?: IWeatherForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateFormatted = data["dateFormatted"] !== undefined ? data["dateFormatted"] : <any>null;
            this.temperatureC = data["temperatureC"] !== undefined ? data["temperatureC"] : <any>null;
            this.summary = data["summary"] !== undefined ? data["summary"] : <any>null;
            this.temperatureF = data["temperatureF"] !== undefined ? data["temperatureF"] : <any>null;
        }
    }

    static fromJS(data: any): WeatherForecast {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFormatted"] = this.dateFormatted !== undefined ? this.dateFormatted : <any>null;
        data["temperatureC"] = this.temperatureC !== undefined ? this.temperatureC : <any>null;
        data["summary"] = this.summary !== undefined ? this.summary : <any>null;
        data["temperatureF"] = this.temperatureF !== undefined ? this.temperatureF : <any>null;
        return data; 
    }

    clone(): WeatherForecast {
        const json = this.toJSON();
        let result = new WeatherForecast();
        result.init(json);
        return result;
    }
}

export interface IWeatherForecast {
    dateFormatted?: string | null;
    temperatureC: number;
    summary?: string | null;
    temperatureF: number;
}

export class GetSeoMetaTextsResponseModel extends ResponseBaseModel implements IGetSeoMetaTextsResponseModel {
    metaTitle?: string | null;
    metaDescription?: string | null;

    constructor(data?: IGetSeoMetaTextsResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.metaTitle = data["metaTitle"] !== undefined ? data["metaTitle"] : <any>null;
            this.metaDescription = data["metaDescription"] !== undefined ? data["metaDescription"] : <any>null;
        }
    }

    static fromJS(data: any): GetSeoMetaTextsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeoMetaTextsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaTitle"] = this.metaTitle !== undefined ? this.metaTitle : <any>null;
        data["metaDescription"] = this.metaDescription !== undefined ? this.metaDescription : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): GetSeoMetaTextsResponseModel {
        const json = this.toJSON();
        let result = new GetSeoMetaTextsResponseModel();
        result.init(json);
        return result;
    }
}

export interface IGetSeoMetaTextsResponseModel extends IResponseBaseModel {
    metaTitle?: string | null;
    metaDescription?: string | null;
}

export abstract class ServiceResponseBase implements IServiceResponseBase {
    isError!: boolean;
    message?: string | null;

    constructor(data?: IServiceResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isError = data["isError"] !== undefined ? data["isError"] : <any>null;
            this.message = data["message"] !== undefined ? data["message"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceResponseBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServiceResponseBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isError"] = this.isError !== undefined ? this.isError : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data; 
    }

    clone(): ServiceResponseBase {
        throw new Error("The abstract class 'ServiceResponseBase' cannot be instantiated.");
    }
}

export interface IServiceResponseBase {
    isError: boolean;
    message?: string | null;
}

export class CreateServiceResponse extends ServiceResponseBase implements ICreateServiceResponse {
    isCreated!: boolean;
    token?: string | null;

    constructor(data?: ICreateServiceResponse) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.isCreated = data["isCreated"] !== undefined ? data["isCreated"] : <any>null;
            this.token = data["token"] !== undefined ? data["token"] : <any>null;
        }
    }

    static fromJS(data: any): CreateServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): CreateServiceResponse {
        const json = this.toJSON();
        let result = new CreateServiceResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceResponse extends IServiceResponseBase {
    isCreated: boolean;
    token?: string | null;
}

export class Subscribe implements ISubscribe {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    period!: Period;

    constructor(data?: ISubscribe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardNumber = data["cardNumber"] !== undefined ? data["cardNumber"] : <any>null;
            this.expirationDate = data["expirationDate"] !== undefined ? data["expirationDate"] : <any>null;
            this.zip = data["zip"] !== undefined ? data["zip"] : <any>null;
            this.securityCode = data["securityCode"] !== undefined ? data["securityCode"] : <any>null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : <any>null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : <any>null;
            this.period = data["period"] !== undefined ? data["period"] : <any>null;
        }
    }

    static fromJS(data: any): Subscribe {
        data = typeof data === 'object' ? data : {};
        let result = new Subscribe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : <any>null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["period"] = this.period !== undefined ? this.period : <any>null;
        return data; 
    }

    clone(): Subscribe {
        const json = this.toJSON();
        let result = new Subscribe();
        result.init(json);
        return result;
    }
}

export interface ISubscribe {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    period: Period;
}

export enum Period {
    Year = 1,
    Month = 2,
    SinglePremiumAd = 3,
}

export class SubscribtionData implements ISubscribtionData {
    subscribtionId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    creditCard?: string | null;
    zip?: string | null;
    type?: string | null;
    price?: string | null;
    nextBillingDate!: moment.Moment;
    status!: Status;

    constructor(data?: ISubscribtionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subscribtionId = data["subscribtionId"] !== undefined ? data["subscribtionId"] : <any>null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : <any>null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : <any>null;
            this.creditCard = data["creditCard"] !== undefined ? data["creditCard"] : <any>null;
            this.zip = data["zip"] !== undefined ? data["zip"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.price = data["price"] !== undefined ? data["price"] : <any>null;
            this.nextBillingDate = data["nextBillingDate"] ? moment(data["nextBillingDate"].toString()) : <any>null;
            this.status = data["status"] !== undefined ? data["status"] : <any>null;
        }
    }

    static fromJS(data: any): SubscribtionData {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribtionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscribtionId"] = this.subscribtionId !== undefined ? this.subscribtionId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["creditCard"] = this.creditCard !== undefined ? this.creditCard : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["nextBillingDate"] = this.nextBillingDate ? this.nextBillingDate.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data; 
    }

    clone(): SubscribtionData {
        const json = this.toJSON();
        let result = new SubscribtionData();
        result.init(json);
        return result;
    }
}

export interface ISubscribtionData {
    subscribtionId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    creditCard?: string | null;
    zip?: string | null;
    type?: string | null;
    price?: string | null;
    nextBillingDate: moment.Moment;
    status: Status;
}

export enum Status {
    Active = 0,
    InActive = 1,
    Canceled = 2,
    Expired = 3,
    Suspended = 4,
    Terminated = 5,
}

export class AddPremiumAdTokenResponse extends ServiceResponseBase implements IAddPremiumAdTokenResponse {
    isCreated!: boolean;

    constructor(data?: IAddPremiumAdTokenResponse) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.isCreated = data["isCreated"] !== undefined ? data["isCreated"] : <any>null;
        }
    }

    static fromJS(data: any): AddPremiumAdTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddPremiumAdTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AddPremiumAdTokenResponse {
        const json = this.toJSON();
        let result = new AddPremiumAdTokenResponse();
        result.init(json);
        return result;
    }
}

export interface IAddPremiumAdTokenResponse extends IServiceResponseBase {
    isCreated: boolean;
}

export class AddPremiumAdToken implements IAddPremiumAdToken {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;

    constructor(data?: IAddPremiumAdToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardNumber = data["cardNumber"] !== undefined ? data["cardNumber"] : <any>null;
            this.expirationDate = data["expirationDate"] !== undefined ? data["expirationDate"] : <any>null;
            this.zip = data["zip"] !== undefined ? data["zip"] : <any>null;
            this.securityCode = data["securityCode"] !== undefined ? data["securityCode"] : <any>null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : <any>null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): AddPremiumAdToken {
        data = typeof data === 'object' ? data : {};
        let result = new AddPremiumAdToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : <any>null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data; 
    }

    clone(): AddPremiumAdToken {
        const json = this.toJSON();
        let result = new AddPremiumAdToken();
        result.init(json);
        return result;
    }
}

export interface IAddPremiumAdToken {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;
}

export class AddWriteAdTokenResponse extends ServiceResponseBase implements IAddWriteAdTokenResponse {
    isCreated!: boolean;

    constructor(data?: IAddWriteAdTokenResponse) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.isCreated = data["isCreated"] !== undefined ? data["isCreated"] : <any>null;
        }
    }

    static fromJS(data: any): AddWriteAdTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddWriteAdTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AddWriteAdTokenResponse {
        const json = this.toJSON();
        let result = new AddWriteAdTokenResponse();
        result.init(json);
        return result;
    }
}

export interface IAddWriteAdTokenResponse extends IServiceResponseBase {
    isCreated: boolean;
}

export class AddWriteAdToken implements IAddWriteAdToken {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;

    constructor(data?: IAddWriteAdToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardNumber = data["cardNumber"] !== undefined ? data["cardNumber"] : <any>null;
            this.expirationDate = data["expirationDate"] !== undefined ? data["expirationDate"] : <any>null;
            this.zip = data["zip"] !== undefined ? data["zip"] : <any>null;
            this.securityCode = data["securityCode"] !== undefined ? data["securityCode"] : <any>null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : <any>null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): AddWriteAdToken {
        data = typeof data === 'object' ? data : {};
        let result = new AddWriteAdToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : <any>null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data; 
    }

    clone(): AddWriteAdToken {
        const json = this.toJSON();
        let result = new AddWriteAdToken();
        result.init(json);
        return result;
    }
}

export interface IAddWriteAdToken {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;
}

export class AddThirdPartyAdTokenResponse extends ServiceResponseBase implements IAddThirdPartyAdTokenResponse {
    isCreated!: boolean;

    constructor(data?: IAddThirdPartyAdTokenResponse) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.isCreated = data["isCreated"] !== undefined ? data["isCreated"] : <any>null;
        }
    }

    static fromJS(data: any): AddThirdPartyAdTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddThirdPartyAdTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AddThirdPartyAdTokenResponse {
        const json = this.toJSON();
        let result = new AddThirdPartyAdTokenResponse();
        result.init(json);
        return result;
    }
}

export interface IAddThirdPartyAdTokenResponse extends IServiceResponseBase {
    isCreated: boolean;
}

export class AddThirdPartyAdToken implements IAddThirdPartyAdToken {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;

    constructor(data?: IAddThirdPartyAdToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardNumber = data["cardNumber"] !== undefined ? data["cardNumber"] : <any>null;
            this.expirationDate = data["expirationDate"] !== undefined ? data["expirationDate"] : <any>null;
            this.zip = data["zip"] !== undefined ? data["zip"] : <any>null;
            this.securityCode = data["securityCode"] !== undefined ? data["securityCode"] : <any>null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : <any>null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): AddThirdPartyAdToken {
        data = typeof data === 'object' ? data : {};
        let result = new AddThirdPartyAdToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : <any>null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data; 
    }

    clone(): AddThirdPartyAdToken {
        const json = this.toJSON();
        let result = new AddThirdPartyAdToken();
        result.init(json);
        return result;
    }
}

export interface IAddThirdPartyAdToken {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;
}

export class AddBanerResponse extends ServiceResponseBase implements IAddBanerResponse {
    isCreated!: boolean;

    constructor(data?: IAddBanerResponse) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.isCreated = data["isCreated"] !== undefined ? data["isCreated"] : <any>null;
        }
    }

    static fromJS(data: any): AddBanerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddBanerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated !== undefined ? this.isCreated : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): AddBanerResponse {
        const json = this.toJSON();
        let result = new AddBanerResponse();
        result.init(json);
        return result;
    }
}

export interface IAddBanerResponse extends IServiceResponseBase {
    isCreated: boolean;
}

export class AddBaner implements IAddBaner {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    banerUrl?: string | null;
    desktopImageHorizontal?: string | null;
    desktopImageVertical?: string | null;
    mobileImage?: string | null;
    isMobile!: number;

    constructor(data?: IAddBaner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardNumber = data["cardNumber"] !== undefined ? data["cardNumber"] : <any>null;
            this.expirationDate = data["expirationDate"] !== undefined ? data["expirationDate"] : <any>null;
            this.zip = data["zip"] !== undefined ? data["zip"] : <any>null;
            this.securityCode = data["securityCode"] !== undefined ? data["securityCode"] : <any>null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : <any>null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : <any>null;
            this.banerUrl = data["banerUrl"] !== undefined ? data["banerUrl"] : <any>null;
            this.desktopImageHorizontal = data["desktopImageHorizontal"] !== undefined ? data["desktopImageHorizontal"] : <any>null;
            this.desktopImageVertical = data["desktopImageVertical"] !== undefined ? data["desktopImageVertical"] : <any>null;
            this.mobileImage = data["mobileImage"] !== undefined ? data["mobileImage"] : <any>null;
            this.isMobile = data["isMobile"] !== undefined ? data["isMobile"] : <any>null;
        }
    }

    static fromJS(data: any): AddBaner {
        data = typeof data === 'object' ? data : {};
        let result = new AddBaner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : <any>null;
        data["expirationDate"] = this.expirationDate !== undefined ? this.expirationDate : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["securityCode"] = this.securityCode !== undefined ? this.securityCode : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["banerUrl"] = this.banerUrl !== undefined ? this.banerUrl : <any>null;
        data["desktopImageHorizontal"] = this.desktopImageHorizontal !== undefined ? this.desktopImageHorizontal : <any>null;
        data["desktopImageVertical"] = this.desktopImageVertical !== undefined ? this.desktopImageVertical : <any>null;
        data["mobileImage"] = this.mobileImage !== undefined ? this.mobileImage : <any>null;
        data["isMobile"] = this.isMobile !== undefined ? this.isMobile : <any>null;
        return data; 
    }

    clone(): AddBaner {
        const json = this.toJSON();
        let result = new AddBaner();
        result.init(json);
        return result;
    }
}

export interface IAddBaner {
    cardNumber?: string | null;
    expirationDate?: string | null;
    zip?: string | null;
    securityCode?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    banerUrl?: string | null;
    desktopImageHorizontal?: string | null;
    desktopImageVertical?: string | null;
    mobileImage?: string | null;
    isMobile: number;
}

export class RegistrationResponseModel extends ResponseBaseModel implements IRegistrationResponseModel {

    constructor(data?: IRegistrationResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): RegistrationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): RegistrationResponseModel {
        const json = this.toJSON();
        let result = new RegistrationResponseModel();
        result.init(json);
        return result;
    }
}

export interface IRegistrationResponseModel extends IResponseBaseModel {
}

export class RegistrationModel implements IRegistrationModel {
    email?: string | null;
    password?: string | null;
    passwordConfirmation?: string | null;
    zipCode?: string | null;
    city?: string | null;
    state?: string | null;
    phone?: string | null;

    constructor(data?: IRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
            this.password = data["password"] !== undefined ? data["password"] : <any>null;
            this.passwordConfirmation = data["passwordConfirmation"] !== undefined ? data["passwordConfirmation"] : <any>null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : <any>null;
            this.city = data["city"] !== undefined ? data["city"] : <any>null;
            this.state = data["state"] !== undefined ? data["state"] : <any>null;
            this.phone = data["phone"] !== undefined ? data["phone"] : <any>null;
        }
    }

    static fromJS(data: any): RegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["passwordConfirmation"] = this.passwordConfirmation !== undefined ? this.passwordConfirmation : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        return data; 
    }

    clone(): RegistrationModel {
        const json = this.toJSON();
        let result = new RegistrationModel();
        result.init(json);
        return result;
    }
}

export interface IRegistrationModel {
    email?: string | null;
    password?: string | null;
    passwordConfirmation?: string | null;
    zipCode?: string | null;
    city?: string | null;
    state?: string | null;
    phone?: string | null;
}

export class ResetPasswordResponseModel extends ResponseBaseModel implements IResetPasswordResponseModel {

    constructor(data?: IResetPasswordResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
    }

    static fromJS(data: any): ResetPasswordResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): ResetPasswordResponseModel {
        const json = this.toJSON();
        let result = new ResetPasswordResponseModel();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordResponseModel extends IResponseBaseModel {
}

export class ResetPasswordModel implements IResetPasswordModel {
    email?: string | null;

    constructor(data?: IResetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data; 
    }

    clone(): ResetPasswordModel {
        const json = this.toJSON();
        let result = new ResetPasswordModel();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordModel {
    email?: string | null;
}

export class GetEmailFromCodeResponseModel extends ResponseBaseModel implements IGetEmailFromCodeResponseModel {
    email?: string | null;

    constructor(data?: IGetEmailFromCodeResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
        }
    }

    static fromJS(data: any): GetEmailFromCodeResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailFromCodeResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): GetEmailFromCodeResponseModel {
        const json = this.toJSON();
        let result = new GetEmailFromCodeResponseModel();
        result.init(json);
        return result;
    }
}

export interface IGetEmailFromCodeResponseModel extends IResponseBaseModel {
    email?: string | null;
}

export class NewPasswordModel implements INewPasswordModel {
    email?: string | null;
    code?: string | null;
    password?: string | null;
    passwordConfirmation?: string | null;

    constructor(data?: INewPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
            this.code = data["code"] !== undefined ? data["code"] : <any>null;
            this.password = data["password"] !== undefined ? data["password"] : <any>null;
            this.passwordConfirmation = data["passwordConfirmation"] !== undefined ? data["passwordConfirmation"] : <any>null;
        }
    }

    static fromJS(data: any): NewPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["passwordConfirmation"] = this.passwordConfirmation !== undefined ? this.passwordConfirmation : <any>null;
        return data; 
    }

    clone(): NewPasswordModel {
        const json = this.toJSON();
        let result = new NewPasswordModel();
        result.init(json);
        return result;
    }
}

export interface INewPasswordModel {
    email?: string | null;
    code?: string | null;
    password?: string | null;
    passwordConfirmation?: string | null;
}

export class ValidateResponseModel extends ResponseBaseModel implements IValidateResponseModel {
    userId!: number;
    userPhone?: string | null;

    constructor(data?: IValidateResponseModel) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.userPhone = data["userPhone"] !== undefined ? data["userPhone"] : <any>null;
        }
    }

    static fromJS(data: any): ValidateResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["userPhone"] = this.userPhone !== undefined ? this.userPhone : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): ValidateResponseModel {
        const json = this.toJSON();
        let result = new ValidateResponseModel();
        result.init(json);
        return result;
    }
}

export interface IValidateResponseModel extends IResponseBaseModel {
    userId: number;
    userPhone?: string | null;
}

export class ValidatePhoneModel implements IValidatePhoneModel {
    code?: string | null;
    userId!: number;

    constructor(data?: IValidatePhoneModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"] !== undefined ? data["code"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): ValidatePhoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatePhoneModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data; 
    }

    clone(): ValidatePhoneModel {
        const json = this.toJSON();
        let result = new ValidatePhoneModel();
        result.init(json);
        return result;
    }
}

export interface IValidatePhoneModel {
    code?: string | null;
    userId: number;
}

export class ValidateModel implements IValidateModel {
    value?: string | null;
    type?: string | null;
    code?: string | null;

    constructor(data?: IValidateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"] !== undefined ? data["value"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.code = data["code"] !== undefined ? data["code"] : <any>null;
        }
    }

    static fromJS(data: any): ValidateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        return data; 
    }

    clone(): ValidateModel {
        const json = this.toJSON();
        let result = new ValidateModel();
        result.init(json);
        return result;
    }
}

export interface IValidateModel {
    value?: string | null;
    type?: string | null;
    code?: string | null;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}